export const giIcons: Array<string> = [
  'bi bi-crosshair',
  'bi bi-crosshair2',
  'bi bi-droplet-fill',
  'bi bi-droplet',
  'bi bi-droplet-half',
  'bi bi-feather',
  'bi bi-flower1',
  'bi bi-flower2',
  'bi bi-flower3',
  'bi bi-flag',
  'bi bi-flag-fill',
  'bi bi-hearts',
  'bi bi-heartbreak',
  'bi bi-heartbreak-fill',
  'bi bi-hourglass-split',
  'bi bi-hypnotize',
  'bi bi-lightning-charge-fill',
  'bi bi-cloud-lightning-rain-fill',
  'bi bi-cloud-rain-heavy-fill',
  'bi bi-cloud-haze-fill',
  'bi bi-cloud-haze2-fill',
  'bi bi-cloud-lightning-rain',
  'bi bi-cloud-rain-heavy',
  'bi bi-cloud-haze',
  'bi bi-bookmark-heart',
  'bi bi-bookmark-heart-fill',
  'bi bi-bookmark-star-fill',
  'bi bi-bookmark-fill',
  'bi bi-bookmark',
  'bi bi-bookmark-star',
  'bi bi-book',
  'bi bi-book-fill',
  'bi bi-stars',
  'bi bi-cloud-moon-fill',
  'bi bi-cloud-moon',
  'bi bi-moon-stars-fill',
  'bi bi-moon-fill',
  'bi bi-moon-stars',
  'bi bi-moon',
  'bi bi-check-lg',
  'bi bi-check',
  'gi-police-badge',
  'gi-riposte',
  'gi-card-10-clubs',
  'gi-card-10-diamonds',
  'gi-card-10-hearts',
  'gi-card-10-spades',
  'gi-card-2-clubs',
  'gi-card-2-diamonds',
  'gi-card-2-hearts',
  'gi-card-2-spades',
  'gi-card-3-clubs',
  'gi-card-3-diamonds',
  'gi-card-3-hearts',
  'gi-card-3-spades',
  'gi-card-4-clubs',
  'gi-card-4-diamonds',
  'gi-card-4-hearts',
  'gi-card-4-spades',
  'gi-card-5-clubs',
  'gi-card-5-diamonds',
  'gi-card-5-hearts',
  'gi-card-5-spades',
  'gi-card-6-clubs',
  'gi-card-6-diamonds',
  'gi-card-6-hearts',
  'gi-card-6-spades',
  'gi-card-7-clubs',
  'gi-card-7-diamonds',
  'gi-card-7-hearts',
  'gi-card-7-spades',
  'gi-card-8-clubs',
  'gi-card-8-diamonds',
  'gi-card-8-hearts',
  'gi-card-8-spades',
  'gi-card-9-clubs',
  'gi-card-9-diamonds',
  'gi-card-9-hearts',
  'gi-card-9-spades',
  'gi-card-ace-clubs',
  'gi-card-ace-diamonds',
  'gi-card-ace-hearts',
  'gi-card-ace-spades',
  'gi-card-jack-clubs',
  'gi-card-jack-diamonds',
  'gi-card-jack-hearts',
  'gi-card-jack-spades',
  'gi-card-king-clubs',
  'gi-card-king-diamonds',
  'gi-card-king-hearts',
  'gi-card-king-spades',
  'gi-card-queen-clubs',
  'gi-card-queen-diamonds',
  'gi-card-queen-hearts',
  'gi-card-queen-spades',
  'gi-brutal-helm',
  'gi-crossbow',
  'gi-flame',
  'gi-mite-alt',
  'gi-spider-alt',
  'gi-spider-face',
  'gi-accordion',
  'gi-anteater',
  'gi-archaeopteryx-fossil',
  'gi-astrolabe',
  'gi-axolotl',
  'gi-bassoon',
  'gi-birch-trees',
  'gi-blender',
  'gi-boar',
  'gi-boba',
  'gi-bok-choy',
  'gi-bowl-of-rice',
  'gi-bunny-slippers',
  'gi-bus-stop',
  'gi-capybara',
  'gi-charcuterie',
  'gi-clarinet',
  'gi-cloaked-figure-on-horseback',
  'gi-clothesline',
  'gi-coinflip',
  'gi-cootie-catcher',
  'gi-deer',
  'gi-deer-head',
  'gi-drum-kit',
  'gi-dumpling',
  'gi-dumpling-bao',
  'gi-earbuds',
  'gi-easel',
  'gi-fox',
  'gi-french-horn',
  'gi-fridge',
  'gi-froe-and-mallet',
  'gi-grand-piano',
  'gi-hedgehog',
  'gi-heraldic-sun',
  'gi-heron',
  'gi-hyena-head',
  'gi-mason-jar',
  'gi-mountain-climbing',
  'gi-pangolin',
  'gi-paper-bag-crumpled',
  'gi-paper-bag-folded',
  'gi-paper-bag-open',
  'gi-paper-crane',
  'gi-paper-frog',
  'gi-philosopher-bust',
  'gi-pianist',
  'gi-pipe-organ',
  'gi-porcupine',
  'gi-pressure-cooker',
  'gi-rice-cooker',
  'gi-rolling-suitcase',
  'gi-rotary-phone',
  'gi-saucepan',
  'gi-sauropod-skeleton',
  'gi-sewing-machine',
  'gi-sloth',
  'gi-slot-machine',
  'gi-soldering-iron',
  'gi-spinning-wheel',
  'gi-stapler',
  'gi-stapler-heavy-duty',
  'gi-stapler-pneumatic',
  'gi-steamroller',
  'gi-tesla-coil',
  'gi-toothbrush',
  'gi-treehouse',
  'gi-trombone',
  'gi-tuba',
  'gi-venus-flytrap',
  'gi-vhs',
  'gi-water-mill',
  'gi-willow-tree',
  'gi-windchimes',
  'gi-wok',
  'gi-annexation',
  'gi-bad-gnome',
  'gi-battleship',
  'gi-boar-ensign',
  'gi-carnyx',
  'gi-carrier',
  'gi-chariot',
  'gi-cruiser',
  'gi-dread',
  'gi-dreadnought',
  'gi-earth-worm',
  'gi-flying-trout',
  'gi-fomorian',
  'gi-great-war-tank',
  'gi-holy-oak',
  'gi-iron-hulled-warship',
  'gi-medusa-head',
  'gi-nun-face',
  'gi-occupy',
  'gi-old-king',
  'gi-oppidum',
  'gi-polar-bear',
  'gi-swordman',
  'gi-swordwoman',
  'gi-torc',
  'gi-transparent-slime',
  'gi-tree-face',
  'gi-tumulus',
  'gi-witch-face',
  'gi-broken-arrow',
  'gi-acrobatic',
  'gi-apothecary',
  'gi-big-gear',
  'gi-catch',
  'gi-cauldron',
  'gi-chameleon-glyph',
  'gi-death-juice',
  'gi-distraction',
  'gi-fish-cooked',
  'gi-flying-shuriken',
  'gi-fried-fish',
  'gi-hooded-assassin',
  'gi-hooded-figure',
  'gi-kusarigama',
  'gi-ninja-head',
  'gi-ninja-heroic-stance',
  'gi-north-star-shuriken',
  'gi-on-sight',
  'gi-plants-and-animals',
  'gi-ram',
  'gi-revolt',
  'gi-robber-hand',
  'gi-running-ninja',
  'gi-severed-hand',
  'gi-sharp-shuriken',
  'gi-shuriken',
  'gi-skull-sabertooth',
  'gi-smoke-bomb',
  'gi-star-shuriken',
  'gi-tabi-boot',
  'gi-three-pointed-shuriken',
  'gi-whirlpool-shuriken',
  'gi-3d-glasses',
  'gi-3d-hammer',
  'gi-3d-meeple',
  'gi-3d-stairs',
  'gi-abacus',
  'gi-abbot-meeple',
  'gi-abdominal-armor',
  'gi-achilles-heel',
  'gi-acoustic-megaphone',
  'gi-africa',
  'gi-agave',
  'gi-ages',
  'gi-air-balloon',
  'gi-air-man',
  'gi-airplane-arrival',
  'gi-airplane-departure',
  'gi-airtight-hatch',
  'gi-akhet',
  'gi-alarm-clock',
  'gi-algae',
  'gi-algeria',
  'gi-alien-bug',
  'gi-alien-egg',
  'gi-all-seeing-eye',
  'gi-almond',
  'gi-amber-mosquito',
  'gi-ambulance',
  'gi-american-football-ball',
  'gi-american-football-helmet',
  'gi-american-football-player',
  'gi-american-shield',
  'gi-amphora',
  'gi-ample-dress',
  'gi-anarchy',
  'gi-ancient-columns',
  'gi-ancient-ruins',
  'gi-ancient-screw',
  'gi-ancient-sword',
  'gi-angola',
  'gi-angry-eyes',
  'gi-animal-hide',
  'gi-ant',
  'gi-antarctica',
  'gi-antibody',
  'gi-anticlockwise-rotation',
  'gi-ants',
  'gi-anubis',
  'gi-apollo-capsule',
  'gi-apple-core',
  'gi-aquarium',
  'gi-aquarius',
  'gi-aqueduct',
  'gi-arabic-door',
  'gi-arch-bridge',
  'gi-archer',
  'gi-archive-register',
  'gi-archive-research',
  'gi-arc-triomphe',
  'gi-aries',
  'gi-arm',
  'gi-armadillo',
  'gi-arm-bandage',
  'gi-armor-downgrade',
  'gi-armored-boomerang',
  'gi-armor-punch',
  'gi-armor-upgrade',
  'gi-arm-sling',
  'gi-arrest',
  'gi-arrow-cursor',
  'gi-arrow-wings',
  'gi-ascending-block',
  'gi-asian-lantern',
  'gi-asparagus',
  'gi-aspergillum',
  'gi-asteroid',
  'gi-astronaut-helmet',
  'gi-atlas',
  'gi-atom-core',
  'gi-attached-shield',
  'gi-audio-cassette',
  'gi-australia',
  'gi-avocado',
  'gi-avoidance',
  'gi-axe-in-log',
  'gi-axe-sword',
  'gi-aztec-calendar-sun',
  'gi-azul-flake',
  'gi-baby-bottle',
  'gi-baby-face',
  'gi-babyfoot-players',
  'gi-backgammon',
  'gi-backpack',
  'gi-backward-time',
  'gi-bacon',
  'gi-bad-breath',
  'gi-bagpipes',
  'gi-ballerina-shoes',
  'gi-balloon-dog',
  'gi-ball-pyramid',
  'gi-bamboo',
  'gi-bamboo-fountain',
  'gi-banana',
  'gi-banana-bunch',
  'gi-banana-peel',
  'gi-banana-peeled',
  'gi-bandana',
  'gi-bandit',
  'gi-banging-gavel',
  'gi-banjo',
  'gi-bank',
  'gi-banknote',
  'gi-baobab',
  'gi-barbarian',
  'gi-barbecue',
  'gi-barn',
  'gi-barracks',
  'gi-barracks-tent',
  'gi-barrel',
  'gi-barrel-leak',
  'gi-barricade',
  'gi-barrier',
  'gi-bar-stool',
  'gi-baseball-bat',
  'gi-baseball-glove',
  'gi-base-dome',
  'gi-basket',
  'gi-basketball-ball',
  'gi-basketball-basket',
  'gi-basketball-jersey',
  'gi-basset-hound-head',
  'gi-bastet',
  'gi-bat',
  'gi-bathtub',
  'gi-bat-leth',
  'gi-bat-mask',
  'gi-battle-mech',
  'gi-beach-bag',
  'gi-beach-ball',
  'gi-beach-bucket',
  'gi-beam-satellite',
  'gi-bear-head',
  'gi-beaver',
  'gi-bed',
  'gi-bed-lamp',
  'gi-beehive',
  'gi-beer-bottle',
  'gi-beer-horn',
  'gi-beet',
  'gi-belgium',
  'gi-bellows',
  'gi-bell-pepper',
  'gi-belt-armor',
  'gi-berries-bowl',
  'gi-berry-bush',
  'gi-biceps',
  'gi-billed-cap',
  'gi-bindle',
  'gi-binoculars',
  'gi-bird-cage',
  'gi-bird-house',
  'gi-bison',
  'gi-black-belt',
  'gi-black-bridge',
  'gi-black-knight-helm',
  'gi-black-sea',
  'gi-blacksmith',
  'gi-blindfold',
  'gi-block-house',
  'gi-bo',
  'gi-boat-engine',
  'gi-boat-fishing',
  'gi-boat-horizon',
  'gi-boat-propeller',
  'gi-body-balance',
  'gi-body-height',
  'gi-bolivia',
  'gi-bolt-bomb',
  'gi-bolt-cutter',
  'gi-bolt-drop',
  'gi-bolt-spell-cast',
  'gi-bone-knife',
  'gi-bone-mace',
  'gi-bonsai-tree',
  'gi-book-cover',
  'gi-book-pile',
  'gi-bookshelf',
  'gi-boombox',
  'gi-boomerang',
  'gi-boomerang-cross',
  'gi-booze',
  'gi-boss-key',
  'gi-bottle-cap',
  'gi-bottled-shadow',
  'gi-boulder-dash',
  'gi-bouncing-spring',
  'gi-bow-arrow',
  'gi-bowels',
  'gi-bowen-knot',
  'gi-bowling-alley',
  'gi-bowling-pin',
  'gi-bowling-strike',
  'gi-bow-string',
  'gi-bow-tie',
  'gi-bow-tie-ribbon',
  'gi-box-cutter',
  'gi-boxing-ring',
  'gi-box-unpacking',
  'gi-bracer',
  'gi-brain-dump',
  'gi-brain-leak',
  'gi-brain-tentacle',
  'gi-brasero',
  'gi-brass-knuckles',
  'gi-brazil',
  'gi-brazil-flag',
  'gi-bread',
  'gi-bread-slice',
  'gi-brick-pile',
  'gi-brick-wall',
  'gi-briefcase',
  'gi-broccoli',
  'gi-broken-axe',
  'gi-broken-pottery',
  'gi-broken-wall',
  'gi-broom',
  'gi-brute',
  'gi-buffalo-head',
  'gi-bug-net',
  'gi-bulgaria',
  'gi-bulldozer',
  'gi-bullet-bill',
  'gi-bullet-impacts',
  'gi-bully-minion',
  'gi-bunk-beds',
  'gi-buoy',
  'gi-burning-forest',
  'gi-bus',
  'gi-bus-doors',
  'gi-butter',
  'gi-butterfly-flower',
  'gi-butterfly-knife',
  'gi-butter-toast',
  'gi-button-finger',
  'gi-buy-card',
  'gi-byzantin-temple',
  'gi-cabbage',
  'gi-cable-stayed-bridge',
  'gi-cactus',
  'gi-cactus-pot',
  'gi-cactus-tap',
  'gi-cadillac-helm',
  'gi-caduceus',
  'gi-caesar',
  'gi-cage',
  'gi-calavera',
  'gi-calculator',
  'gi-calendar',
  'gi-calendar-half-year',
  'gi-caltrops',
  'gi-camargue-cross',
  'gi-cambodia',
  'gi-camel',
  'gi-camel-head',
  'gi-camp-cooking-pot',
  'gi-camping-tent',
  'gi-cancer',
  'gi-candles',
  'gi-candlestick-phone',
  'gi-candy-canes',
  'gi-canned-fish',
  'gi-canoe',
  'gi-cantua',
  'gi-cape',
  'gi-cape-armor',
  'gi-capricorn',
  'gi-captain-hat-profile',
  'gi-carabiner',
  'gi-carambola',
  'gi-caravan',
  'gi-caravel',
  'gi-car-battery',
  'gi-cardboard-box',
  'gi-cardboard-box-closed',
  'gi-card-burn',
  'gi-card-exchange',
  'gi-card-joker',
  'gi-car-door',
  'gi-cargo-crate',
  'gi-cargo-ship',
  'gi-car-key',
  'gi-carnival-mask',
  'gi-carnivorous-plant',
  'gi-carousel',
  'gi-carrot',
  'gi-car-seat',
  'gi-car-wheel',
  'gi-cassowary-head',
  'gi-castle',
  'gi-castle-ruins',
  'gi-caterpillar',
  'gi-cavalry',
  'gi-cave-entrance',
  'gi-caveman',
  'gi-cctv-camera',
  'gi-ceiling-barnacle',
  'gi-ceiling-light',
  'gi-cellar-barrels',
  'gi-centaur',
  'gi-centaur-heart',
  'gi-centurion-helmet',
  'gi-ceremonial-mask',
  'gi-chainsaw',
  'gi-chakram',
  'gi-chalk-outline-murder',
  'gi-champagne-cork',
  'gi-champions',
  'gi-chanterelles',
  'gi-character',
  'gi-charging',
  'gi-charging-bull',
  'gi-chart',
  'gi-chat-bubble',
  'gi-checkered-flag',
  'gi-checklist',
  'gi-check-mark',
  'gi-chef-toque',
  'gi-chelsea-boot',
  'gi-cherish',
  'gi-cherry',
  'gi-chest',
  'gi-chest-armor',
  'gi-chestnut-leaf',
  'gi-chicken',
  'gi-chicken-oven',
  'gi-chili-pepper',
  'gi-chimney',
  'gi-chips-bag',
  'gi-chisel',
  'gi-choice',
  'gi-chopsticks',
  'gi-church',
  'gi-cigale',
  'gi-cigar',
  'gi-cigarette',
  'gi-circle',
  'gi-circle-forest',
  'gi-circling-fish',
  'gi-city-car',
  'gi-clamp',
  'gi-clapperboard',
  'gi-classical-knowledge',
  'gi-claws',
  'gi-clay-brick',
  'gi-claymore-explosive',
  'gi-cleaver',
  'gi-cleopatra',
  'gi-cliff-crossing',
  'gi-clockwise-rotation',
  'gi-closed-barbute',
  'gi-closed-doors',
  'gi-clothes',
  'gi-clothespin',
  'gi-cloth-jar',
  'gi-cloud-download',
  'gi-cloud-upload',
  'gi-clown',
  'gi-clownfish',
  'gi-coa-de-jima',
  'gi-coal-pile',
  'gi-coal-wagon',
  'gi-cobra',
  'gi-coconuts',
  'gi-coffee-beans',
  'gi-coffee-cup',
  'gi-coffee-pot',
  'gi-coiled-nail',
  'gi-coins',
  'gi-coins-pile',
  'gi-coliseum',
  'gi-colombia',
  'gi-colombian-statue',
  'gi-column-vase',
  'gi-commercial-airplane',
  'gi-compact-disc',
  'gi-companion-cube',
  'gi-computer-fan',
  'gi-concrete-bag',
  'gi-confirmed',
  'gi-confrontation',
  'gi-congress',
  'gi-conqueror',
  'gi-contortionist',
  'gi-contract',
  'gi-control-tower',
  'gi-convergence-target',
  'gi-converse-shoe',
  'gi-convict',
  'gi-convince',
  'gi-conway-life-glider',
  'gi-cook',
  'gi-cookie',
  'gi-cooking-glove',
  'gi-cooking-pot',
  'gi-cooler',
  'gi-coral',
  'gi-cork-hat',
  'gi-corkscrew',
  'gi-corn',
  'gi-corner-flag',
  'gi-cornucopia',
  'gi-coronation',
  'gi-corporal',
  'gi-corset',
  'gi-corsica',
  'gi-cosmic-egg',
  'gi-cotton-flower',
  'gi-covered-jar',
  'gi-cow',
  'gi-cowboy-boot',
  'gi-cowboy-holster',
  'gi-cpu',
  'gi-crafting',
  'gi-crane',
  'gi-credits-currency',
  'gi-crenel-crown',
  'gi-crescent-staff',
  'gi-cricket',
  'gi-cricket-bat',
  'gi-crime-scene-tape',
  'gi-croissant',
  'gi-crook-flail',
  'gi-crosscut-saw',
  'gi-crosshair',
  'gi-crossroad',
  'gi-cross-shield',
  'gi-crowbar',
  'gi-crow-nest',
  'gi-crucifix',
  'gi-cryo-chamber',
  'gi-crypt-entrance',
  'gi-crystal-earrings',
  'gi-crystal-shrine',
  'gi-cuauhtli',
  'gi-cube',
  'gi-cuckoo-clock',
  'gi-cupcake',
  'gi-curling-stone',
  'gi-custodian-helmet',
  'gi-cut-lemon',
  'gi-cyber-eye',
  'gi-cyborg-face',
  'gi-cycling',
  'gi-daemon-pull',
  'gi-dagger-rose',
  'gi-dam',
  'gi-dandelion-flower',
  'gi-dango',
  'gi-dart',
  'gi-database',
  'gi-dead-head',
  'gi-death-star',
  'gi-deer-track',
  'gi-defense-satellite',
  'gi-deku-tree',
  'gi-delicate-perfume',
  'gi-delivery-drone',
  'gi-desert',
  'gi-desert-camp',
  'gi-deshret-red-crown',
  'gi-desk',
  'gi-detonator',
  'gi-detour',
  'gi-devil-mask',
  'gi-dial-padlock',
  'gi-diamond-hilt',
  'gi-diamond-ring',
  'gi-diamond-trophy',
  'gi-dice-eight-faces-eight',
  'gi-dice-fire',
  'gi-dice-shield',
  'gi-dice-six-faces-five',
  'gi-dice-six-faces-four',
  'gi-dice-six-faces-one',
  'gi-dice-six-faces-six',
  'gi-dice-six-faces-three',
  'gi-dice-six-faces-two',
  'gi-dice-target',
  'gi-dice-twenty-faces-one',
  'gi-dice-twenty-faces-twenty',
  'gi-dig-hole',
  'gi-dimetrodon',
  'gi-diplodocus',
  'gi-diploma',
  'gi-direction-sign',
  'gi-direction-signs',
  'gi-director-chair',
  'gi-disc-golf-bag',
  'gi-disc-golf-basket',
  'gi-discobolus',
  'gi-discussion',
  'gi-distress-signal',
  'gi-diving-helmet',
  'gi-djed-pillar',
  'gi-djembe',
  'gi-djinn',
  'gi-dog-bowl',
  'gi-dog-house',
  'gi-dolmen',
  'gi-dolphin',
  'gi-domino-tiles',
  'gi-doner-kebab',
  'gi-donut',
  'gi-door',
  'gi-door-handle',
  'gi-door-ring-handle',
  'gi-door-watcher',
  'gi-double-fish',
  'gi-double-necklace',
  'gi-double-street-lights',
  'gi-dough-roller',
  'gi-dragon-orb',
  'gi-dragon-shield',
  'gi-drakkar',
  'gi-drakkar-dragon',
  'gi-drawbridge',
  'gi-dream-catcher',
  'gi-drill',
  'gi-drinking',
  'gi-drop-earrings',
  'gi-drum',
  'gi-duck',
  'gi-duck-palm',
  'gi-duffel-bag',
  'gi-dunce-cap',
  'gi-dungeon-gate',
  'gi-dungeon-light',
  'gi-duration',
  'gi-dutch-bike',
  'gi-dwarf-face',
  'gi-dwennimmen',
  'gi-dynamite',
  'gi-eagle-head',
  'gi-earrings',
  'gi-earth-africa-europe',
  'gi-earth-america',
  'gi-earth-asia-oceania',
  'gi-easter-egg',
  'gi-eating',
  'gi-eating-pelican',
  'gi-ecology',
  'gi-eel',
  'gi-egg-eye',
  'gi-egypt',
  'gi-egyptian-bird',
  'gi-egyptian-profile',
  'gi-egyptian-pyramids',
  'gi-egyptian-sphinx',
  'gi-egyptian-temple',
  'gi-egyptian-urns',
  'gi-egyptian-walk',
  'gi-eight-ball',
  'gi-elbow-pad',
  'gi-electrical-resistance',
  'gi-electrical-socket',
  'gi-elephant',
  'gi-elephant-head',
  'gi-elevator',
  'gi-elf-ear',
  'gi-elysium-shade',
  'gi-emerald-necklace',
  'gi-empty-chessboard',
  'gi-empty-metal-bucket',
  'gi-empty-metal-bucket-handle',
  'gi-empty-wood-bucket',
  'gi-empty-wood-bucket-handle',
  'gi-encirclement',
  'gi-energy-tank',
  'gi-enrage',
  'gi-entry-door',
  'gi-ermine',
  'gi-escalator',
  'gi-eternal-love',
  'gi-european-flag',
  'gi-evasion',
  'gi-evil-love',
  'gi-evil-tower',
  'gi-executioner-hood',
  'gi-exit-door',
  'gi-expand',
  'gi-expense',
  'gi-exploding-planet',
  'gi-extra-time',
  'gi-eyelashes',
  'gi-eye-of-horus',
  'gi-eyepatch',
  'gi-eye-target',
  'gi-face-to-face',
  'gi-factory',
  'gi-factory-arm',
  'gi-fairy',
  'gi-fairy-wings',
  'gi-falcon-moon',
  'gi-falling-bomb',
  'gi-falling-rocks',
  'gi-falling-star',
  'gi-fallout-shelter',
  'gi-family-house',
  'gi-family-tree',
  'gi-farmer',
  'gi-farm-tractor',
  'gi-fast-backward-button',
  'gi-fast-forward-button',
  'gi-fast-noodles',
  'gi-f-clef',
  'gi-feather-necklace',
  'gi-feline',
  'gi-female',
  'gi-female-legs',
  'gi-female-vampire',
  'gi-fencer',
  'gi-fern',
  'gi-fertilizer-bag',
  'gi-fez',
  'gi-figurehead',
  'gi-files',
  'gi-film-projector',
  'gi-film-spool',
  'gi-film-strip',
  'gi-finch',
  'gi-fingernail',
  'gi-finger-print',
  'gi-finish-line',
  'gi-fire-extinguisher',
  'gi-fire-flower',
  'gi-fire-gem',
  'gi-fireplace',
  'gi-fire-shrine',
  'gi-fire-spell-cast',
  'gi-firewall',
  'gi-first-aid-kit',
  'gi-fish-bucket',
  'gi-fish-eggs',
  'gi-fish-escape',
  'gi-fishing',
  'gi-fishing-boat',
  'gi-fishing-jig',
  'gi-fishing-lure',
  'gi-fishing-pole',
  'gi-fishing-spoon',
  'gi-fish-monster',
  'gi-fish-scales',
  'gi-fish-smoking',
  'gi-flag-objective',
  'gi-flail',
  'gi-flamethrower',
  'gi-flamethrower-soldier',
  'gi-flamingo',
  'gi-flanged-mace',
  'gi-flashlight',
  'gi-flatfish',
  'gi-flat-platform',
  'gi-flat-tire',
  'gi-flax',
  'gi-fleur-de-lys',
  'gi-flexible-lamp',
  'gi-flint-spark',
  'gi-flip-flops',
  'gi-floating-ghost',
  'gi-floating-platforms',
  'gi-floating-tentacles',
  'gi-flood',
  'gi-floor-hatch',
  'gi-floor-polisher',
  'gi-flour',
  'gi-flower-emblem',
  'gi-flower-hat',
  'gi-flower-star',
  'gi-flute',
  'gi-fly',
  'gi-flying-beetle',
  'gi-flying-fox',
  'gi-flying-target',
  'gi-fog',
  'gi-fog-light',
  'gi-food-truck',
  'gi-foot-plaster',
  'gi-footy-field',
  'gi-forearm',
  'gi-forest',
  'gi-forest-camp',
  'gi-forest-entrance',
  'gi-fork-knife-spoon',
  'gi-forklift',
  'gi-foundry-bucket',
  'gi-fox-tail',
  'gi-france',
  'gi-freemasonry',
  'gi-french-fries',
  'gi-fried-eggs',
  'gi-frisbee',
  'gi-frog-foot',
  'gi-frog-prince',
  'gi-frozen-body',
  'gi-frozen-ring',
  'gi-fruit-tree',
  'gi-fuel-tank',
  'gi-fuji',
  'gi-full-folder',
  'gi-full-metal-bucket',
  'gi-full-metal-bucket-handle',
  'gi-full-motorcycle-helmet',
  'gi-full-pizza',
  'gi-full-wood-bucket',
  'gi-full-wood-bucket-handle',
  'gi-funnel',
  'gi-fur-boot',
  'gi-furnace',
  'gi-fur-shirt',
  'gi-galaxy',
  'gi-galea',
  'gi-galley',
  'gi-game-console',
  'gi-gamepad',
  'gi-gardening-shears',
  'gi-gargoyle',
  'gi-garlic',
  'gi-gas-pump',
  'gi-gas-stove',
  'gi-gate',
  'gi-gauls-helm',
  'gi-gauntlet',
  'gi-g-clef',
  'gi-gear-stick',
  'gi-gear-stick-pattern',
  'gi-gemini',
  'gi-giant',
  'gi-giant-squid',
  'gi-gingerbread-man',
  'gi-ginkgo-leaf',
  'gi-glaive',
  'gi-glass-ball',
  'gi-glass-celebration',
  'gi-globe-ring',
  'gi-gloves',
  'gi-glowing-artifact',
  'gi-goal-keeper',
  'gi-goblin-camp',
  'gi-goblin-head',
  'gi-gold-mine',
  'gi-gold-nuggets',
  'gi-gold-stack',
  'gi-golem-head',
  'gi-golf-flag',
  'gi-golf-tee',
  'gi-gong',
  'gi-goose',
  'gi-gorilla',
  'gi-gps',
  'gi-graduate-cap',
  'gi-grain',
  'gi-grain-bundle',
  'gi-granary',
  'gi-grasping-slug',
  'gi-grass',
  'gi-grass-mushroom',
  'gi-grave-flowers',
  'gi-graveyard',
  'gi-great-pyramid',
  'gi-greaves',
  'gi-greek-sphinx',
  'gi-greek-temple',
  'gi-greenhouse',
  'gi-green-power',
  'gi-griffin-shield',
  'gi-griffin-symbol',
  'gi-growth',
  'gi-guards',
  'gi-guatemala',
  'gi-guitar-bass-head',
  'gi-guitar-head',
  'gi-gun-rose',
  'gi-gun-stock',
  'gi-gym-bag',
  'gi-h2o',
  'gi-habitat-dome',
  'gi-hades-symbol',
  'gi-hair-strands',
  'gi-half-body-crawling',
  'gi-half-dead',
  'gi-half-log',
  'gi-hamburger',
  'gi-hamburger-menu',
  'gi-hammer-break',
  'gi-hammer-sickle',
  'gi-hand-bag',
  'gi-hand-bandage',
  'gi-handcuffed',
  'gi-hand-grip',
  'gi-handheld-fan',
  'gi-hand-of-god',
  'gi-hand-ok',
  'gi-hand-saw',
  'gi-hand-truck',
  'gi-hand-wing',
  'gi-hanger',
  'gi-hang-glider',
  'gi-hanging-sign',
  'gi-harbor-dock',
  'gi-harp',
  'gi-hatchet',
  'gi-hazmat-suit',
  'gi-headband-knot',
  'gi-headphones',
  'gi-healing',
  'gi-healing-shield',
  'gi-health-capsule',
  'gi-health-potion',
  'gi-heart-armor',
  'gi-heart-battery',
  'gi-heart-beats',
  'gi-heart-earrings',
  'gi-heart-key',
  'gi-heart-necklace',
  'gi-heart-shield',
  'gi-heart-stake',
  'gi-heart-wings',
  'gi-heaven-gate',
  'gi-heavy-bullets',
  'gi-heavy-collar',
  'gi-hedjet-white-crown',
  'gi-helicoprion',
  'gi-helicopter',
  'gi-helicopter-tail',
  'gi-hell-crosses',
  'gi-hemp',
  'gi-heptagram',
  'gi-herbs-bundle',
  'gi-hexagonal-nut',
  'gi-hieroglyph-legs',
  'gi-hieroglyph-y',
  'gi-high-grass',
  'gi-high-heel',
  'gi-high-kick',
  'gi-highlighter',
  'gi-high-punch',
  'gi-high-tide',
  'gi-hiking',
  'gi-hill-conquest',
  'gi-hill-fort',
  'gi-hills',
  'gi-histogram',
  'gi-hive-mind',
  'gi-hobbit-door',
  'gi-hobbit-dwelling',
  'gi-hockey',
  'gi-hole',
  'gi-hole-ladder',
  'gi-holy-hand-grenade',
  'gi-holy-water',
  'gi-home-garage',
  'gi-honey-jar',
  'gi-hoodie',
  'gi-hook',
  'gi-hops',
  'gi-horizon-road',
  'gi-horizontal-flip',
  'gi-horned-reptile',
  'gi-horse-head',
  'gi-horseshoe',
  'gi-horus',
  'gi-hospital',
  'gi-hot-dog',
  'gi-hot-meal',
  'gi-house',
  'gi-house-keys',
  'gi-human-cannonball',
  'gi-human-ear',
  'gi-human-pyramid',
  'gi-human-target',
  'gi-hummingbird',
  'gi-hungary',
  'gi-hunter-eyes',
  'gi-hunting-bolas',
  'gi-hut',
  'gi-huts-village',
  'gi-i-beam',
  'gi-ibis',
  'gi-i-brick',
  'gi-icarus',
  'gi-iceberg',
  'gi-ice-cream-cone',
  'gi-ice-cream-scoop',
  'gi-ice-cubes',
  'gi-ice-golem',
  'gi-ice-iris',
  'gi-iceland',
  'gi-ice-pop',
  'gi-ice-skate',
  'gi-ice-spell-cast',
  'gi-id-card',
  'gi-idea',
  'gi-igloo',
  'gi-imperial-crown',
  'gi-inauguration',
  'gi-incubator',
  'gi-india-gate',
  'gi-indian-palace',
  'gi-inferno-bomb',
  'gi-info',
  'gi-injustice',
  'gi-inspiration',
  'gi-interceptor-ship',
  'gi-intricate-necklace',
  'gi-invisible',
  'gi-invisible-face',
  'gi-ionic-column',
  'gi-iraq',
  'gi-island',
  'gi-italia',
  'gi-ivory-tusks',
  'gi-jack-plug',
  'gi-japan',
  'gi-japanese-bridge',
  'gi-jasmine',
  'gi-jason-mask',
  'gi-jawless-cyclop',
  'gi-j-brick',
  'gi-jeep',
  'gi-jelly',
  'gi-jelly-beans',
  'gi-jerrycan',
  'gi-jerusalem-cross',
  'gi-jester-hat',
  'gi-jet-fighter',
  'gi-jewel-crown',
  'gi-join',
  'gi-joystick',
  'gi-jug',
  'gi-juggling-clubs',
  'gi-juggling-seal',
  'gi-jump-across',
  'gi-jumping-dog',
  'gi-jumping-rope',
  'gi-jungle',
  'gi-jupiter',
  'gi-kangaroo',
  'gi-katana',
  'gi-kebab-spit',
  'gi-kenku-head',
  'gi-kenya',
  'gi-ketchup',
  'gi-keyboard',
  'gi-key-card',
  'gi-key-lock',
  'gi-keyring',
  'gi-kick-scooter',
  'gi-kidneys',
  'gi-kid-slide',
  'gi-kimono',
  'gi-king-ju-mask',
  'gi-kitchen-scale',
  'gi-kitchen-tap',
  'gi-kite',
  'gi-kiwi-bird',
  'gi-kiwi-fruit',
  'gi-klingon',
  'gi-knee-bandage',
  'gi-knee-cap',
  'gi-kneeling',
  'gi-knee-pad',
  'gi-knight-banner',
  'gi-knocked-out-stars',
  'gi-knot',
  'gi-koala',
  'gi-koholint-egg',
  'gi-kraken-tentacle',
  'gi-lab-coat',
  'gi-labrador-head',
  'gi-ladder',
  'gi-ladders-platform',
  'gi-ladle',
  'gi-ladybug',
  'gi-laptop',
  'gi-large-dress',
  'gi-large-paint-brush',
  'gi-laser-turret',
  'gi-lasso',
  'gi-latvia',
  'gi-laurels-trophy',
  'gi-l-brick',
  'gi-lead-pipe',
  'gi-leak',
  'gi-leapfrog',
  'gi-leather-armor',
  'gi-led',
  'gi-leek',
  'gi-leg',
  'gi-leg-armor',
  'gi-lemon',
  'gi-leo',
  'gi-level-crossing',
  'gi-level-end-flag',
  'gi-liar',
  'gi-liberty-wing',
  'gi-libra',
  'gi-libya',
  'gi-life-bar',
  'gi-life-buoy',
  'gi-life-jacket',
  'gi-light-backpack',
  'gi-lighter',
  'gi-light-helm',
  'gi-lighthouse',
  'gi-lightning-dome',
  'gi-lightning-flame',
  'gi-light-projector',
  'gi-light-sabers',
  'gi-lily-pads',
  'gi-lipstick',
  'gi-liquid-soap',
  'gi-liver',
  'gi-load',
  'gi-locked-box',
  'gi-locked-door',
  'gi-locked-heart',
  'gi-lockers',
  'gi-lock-picking',
  'gi-lockpicks',
  'gi-lock-spy',
  'gi-log',
  'gi-logic-gate-and',
  'gi-logic-gate-nand',
  'gi-logic-gate-nor',
  'gi-logic-gate-not',
  'gi-logic-gate-nxor',
  'gi-logic-gate-or',
  'gi-logic-gate-xor',
  'gi-loincloth',
  'gi-look-at',
  'gi-lorgnette',
  'gi-louvre-pyramid',
  'gi-love-letter',
  'gi-love-mystery',
  'gi-lovers',
  'gi-low-tide',
  'gi-luchador',
  'gi-lucky-fisherman',
  'gi-lunar-module',
  'gi-lunar-wand',
  'gi-lungs',
  'gi-lynx-head',
  'gi-machine-gun-magazine',
  'gi-magic-axe',
  'gi-magic-broom',
  'gi-magic-hat',
  'gi-magick-trick',
  'gi-magic-potion',
  'gi-magic-trident',
  'gi-magnet-man',
  'gi-mailbox',
  'gi-male',
  'gi-mammoth',
  'gi-mandrill-head',
  'gi-manta-ray',
  'gi-manual-juicer',
  'gi-manual-meat-grinder',
  'gi-maracas',
  'gi-marbles',
  'gi-marble-tap',
  'gi-mars-curiosity',
  'gi-marshmallows',
  'gi-mars-pathfinder',
  'gi-martyr-memorial',
  'gi-matchbox',
  'gi-matryoshka-dolls',
  'gi-matter-states',
  'gi-mayan-pyramid',
  'gi-meal',
  'gi-measure-tape',
  'gi-mecha-head',
  'gi-mecha-mask',
  'gi-mechanic-garage',
  'gi-medallist',
  'gi-medical-drip',
  'gi-medical-thermometer',
  'gi-medicine-pills',
  'gi-medicines',
  'gi-medieval-barracks',
  'gi-medieval-gate',
  'gi-medieval-pavilion',
  'gi-meeple',
  'gi-meeple-army',
  'gi-meeple-circle',
  'gi-meeple-group',
  'gi-meeple-king',
  'gi-megaphone',
  'gi-melting-ice-cube',
  'gi-melting-metal',
  'gi-menhir',
  'gi-mermaid',
  'gi-mesh-network',
  'gi-metal-boot',
  'gi-metal-detector',
  'gi-metal-golem-head',
  'gi-metal-plate',
  'gi-metal-skirt',
  'gi-metroid',
  'gi-metronome',
  'gi-mexico',
  'gi-microphone',
  'gi-mighty-boosh',
  'gi-mighty-force',
  'gi-mighty-horn',
  'gi-military-fort',
  'gi-millenium-key',
  'gi-mimic-chest',
  'gi-miner',
  'gi-mineral-pearls',
  'gi-mine-truck',
  'gi-mine-wagon',
  'gi-mining-helmet',
  'gi-mini-submarine',
  'gi-misdirection',
  'gi-missile-launcher',
  'gi-moai',
  'gi-modern-city',
  'gi-moka-pot',
  'gi-moldova',
  'gi-mona-lisa',
  'gi-moncler-jacket',
  'gi-money-stack',
  'gi-mongolia',
  'gi-monkey-wrench',
  'gi-monk-face',
  'gi-mono-wheel-robot',
  'gi-monstera-leaf',
  'gi-monument-valley',
  'gi-moon-bats',
  'gi-moon-orbit',
  'gi-mooring-bollard',
  'gi-morgue-feet',
  'gi-morph-ball',
  'gi-mortar',
  'gi-mountain-cave',
  'gi-mountain-road',
  'gi-mouse',
  'gi-move',
  'gi-mp5',
  'gi-mug-shot',
  'gi-multi-directions',
  'gi-multiple-targets',
  'gi-mummy-head',
  'gi-muscular-torso',
  'gi-mushroom-house',
  'gi-mushrooms',
  'gi-mushrooms-cluster',
  'gi-musical-keyboard',
  'gi-musical-notes',
  'gi-musical-score',
  'gi-mussel',
  'gi-mustache',
  'gi-mute',
  'gi-nachos',
  'gi-nano-bot',
  'gi-neck-bite',
  'gi-necklace-display',
  'gi-nectar',
  'gi-nefertiti',
  'gi-nest-birds',
  'gi-nested-hearts',
  'gi-nested-hexagons',
  'gi-nest-eggs',
  'gi-network-bars',
  'gi-new-born',
  'gi-newspaper',
  'gi-next-button',
  'gi-nigeria',
  'gi-night-sleep',
  'gi-night-vision',
  'gi-ninja-armor',
  'gi-ninja-velociraptor',
  'gi-noodles',
  'gi-nose-front',
  'gi-nose-side',
  'gi-notebook',
  'gi-nuclear-plant',
  'gi-nuclear-waste',
  'gi-nunchaku',
  'gi-nurse-female',
  'gi-nurse-male',
  'gi-oak-leaf',
  'gi-oasis',
  'gi-obelisk',
  'gi-o-brick',
  'gi-observatory',
  'gi-ocarina',
  'gi-oden',
  'gi-office-chair',
  'gi-offshore-platform',
  'gi-ogre',
  'gi-oil-pump',
  'gi-oil-rig',
  'gi-old-lantern',
  'gi-old-microphone',
  'gi-old-wagon',
  'gi-olive',
  'gi-oni',
  'gi-onigori',
  'gi-opened-food-can',
  'gi-open-folder',
  'gi-open-gate',
  'gi-ophiuchus',
  'gi-opposite-hearts',
  'gi-orange',
  'gi-orange-slice',
  'gi-orc-head',
  'gi-organigram',
  'gi-ostrich',
  'gi-outback-hat',
  'gi-overlord-helm',
  'gi-oyster',
  'gi-oyster-pearl',
  'gi-packed-planks',
  'gi-paddles',
  'gi-paddle-steamer',
  'gi-padlock-open',
  'gi-pagoda',
  'gi-paint-brush',
  'gi-paint-bucket',
  'gi-painted-pottery',
  'gi-paint-roller',
  'gi-palette',
  'gi-palisade',
  'gi-palm-tree',
  'gi-panda',
  'gi-pan-flute',
  'gi-panzerfaust',
  'gi-paper-boat',
  'gi-paper-clip',
  'gi-paper-plane',
  'gi-paper-tray',
  'gi-paper-windmill',
  'gi-papyrus',
  'gi-paraguay',
  'gi-parasaurolophus',
  'gi-park-bench',
  'gi-party-flags',
  'gi-party-hat',
  'gi-party-popper',
  'gi-passport',
  'gi-path-distance',
  'gi-path-tile',
  'gi-pay-money',
  'gi-peace-dove',
  'gi-peach',
  'gi-pear',
  'gi-pearl-earring',
  'gi-pearl-necklace',
  'gi-peas',
  'gi-pelvis-bone',
  'gi-pencil',
  'gi-pencil-brush',
  'gi-pencil-ruler',
  'gi-pendant-key',
  'gi-pendulum-swing',
  'gi-penguin',
  'gi-periscope',
  'gi-person',
  'gi-person-in-bed',
  'gi-perspective-dice-five',
  'gi-perspective-dice-four',
  'gi-perspective-dice-one',
  'gi-perspective-dice-six',
  'gi-perspective-dice-six-faces-five',
  'gi-perspective-dice-six-faces-four',
  'gi-perspective-dice-six-faces-one',
  'gi-perspective-dice-six-faces-random',
  'gi-perspective-dice-six-faces-six',
  'gi-perspective-dice-six-faces-three',
  'gi-perspective-dice-six-faces-two',
  'gi-perspective-dice-three',
  'gi-perspective-dice-two',
  'gi-peru',
  'gi-pharoah',
  'gi-phone',
  'gi-photo-camera',
  'gi-phrygian-cap',
  'gi-piano-keys',
  'gi-pickle',
  'gi-pick-of-destiny',
  'gi-pie-chart',
  'gi-piggy-bank',
  'gi-pikeman',
  'gi-pilgrim-hat',
  'gi-pillow',
  'gi-pimiento',
  'gi-pin',
  'gi-pinata',
  'gi-pinball-flipper',
  'gi-pineapple',
  'gi-ping-pong-bat',
  'gi-pipes',
  'gi-piranha',
  'gi-pirate-cannon',
  'gi-pirate-captain',
  'gi-pirate-coat',
  'gi-pirate-flag',
  'gi-pirate-hat',
  'gi-pirate-hook',
  'gi-pisa-tower',
  'gi-pisces',
  'gi-pitchfork',
  'gi-pizza-slice',
  'gi-plague-doctor-profile',
  'gi-plain-arrow',
  'gi-plain-circle',
  'gi-plain-square',
  'gi-plane-pilot',
  'gi-planet-conquest',
  'gi-planet-core',
  'gi-plane-wing',
  'gi-planks',
  'gi-plant-roots',
  'gi-plant-seed',
  'gi-plant-watering',
  'gi-plastic-duck',
  'gi-player-base',
  'gi-player-next',
  'gi-player-previous',
  'gi-player-time',
  'gi-plesiosaurus',
  'gi-plow',
  'gi-plug',
  'gi-plunger',
  'gi-pocket-radio',
  'gi-podium',
  'gi-podium-second',
  'gi-podium-third',
  'gi-podium-winner',
  'gi-poland',
  'gi-polar-star',
  'gi-police-car',
  'gi-police-officer-head',
  'gi-police-target',
  'gi-polo-shirt',
  'gi-poncho',
  'gi-pool-dive',
  'gi-pool-table-corner',
  'gi-pool-triangle',
  'gi-popcorn',
  'gi-pope-crown',
  'gi-porcelain-vase',
  'gi-porcupinefish',
  'gi-portrait',
  'gi-portugal',
  'gi-position-marker',
  'gi-post-office',
  'gi-post-stamp',
  'gi-potato',
  'gi-pouring-pot',
  'gi-powder-bag',
  'gi-power-generator',
  'gi-power-ring',
  'gi-prayer-beads',
  'gi-praying-mantis',
  'gi-present',
  'gi-pretzel',
  'gi-previous-button',
  'gi-price-tag',
  'gi-primitive-necklace',
  'gi-primitive-torch',
  'gi-prism',
  'gi-prisoner',
  'gi-private',
  'gi-private-first-class',
  'gi-progression',
  'gi-propeller-beanie',
  'gi-protection-glasses',
  'gi-pschent-double-crown',
  'gi-pterodactylus',
  'gi-public-speaker',
  'gi-pull',
  'gi-pulley-hook',
  'gi-pumpkin',
  'gi-punching-bag',
  'gi-purple-tentacle',
  'gi-push',
  'gi-puzzle',
  'gi-pylon',
  'gi-pyre',
  'gi-qaitbay-citadel',
  'gi-quick-man',
  'gi-quiver',
  'gi-rabbit',
  'gi-rabbit-head',
  'gi-raccoon-head',
  'gi-radar-cross-section',
  'gi-raddish',
  'gi-radiations',
  'gi-radio-tower',
  'gi-raft',
  'gi-rail-road',
  'gi-railway',
  'gi-rake',
  'gi-ram-profile',
  'gi-ranch-gate',
  'gi-raspberry',
  'gi-rat',
  'gi-rattlesnake',
  'gi-raw-egg',
  'gi-razor',
  'gi-receive-money',
  'gi-red-carpet',
  'gi-reed',
  'gi-refinery',
  'gi-reload-gun-barrel',
  'gi-remedy',
  'gi-rempart',
  'gi-reptile-tail',
  'gi-resize',
  'gi-resting-vampire',
  'gi-revolver',
  'gi-rhinoceros-horn',
  'gi-rialto-bridge',
  'gi-ribbon-medal',
  'gi-ribbon-shield',
  'gi-ring',
  'gi-ring-box',
  'gi-ringing-alarm',
  'gi-ringmaster',
  'gi-ring-mould',
  'gi-river',
  'gi-road',
  'gi-robber',
  'gi-robber-mask',
  'gi-robin-hood-hat',
  'gi-robot-antennas',
  'gi-robot-grab',
  'gi-robot-helmet',
  'gi-robot-leg',
  'gi-rocket-thruster',
  'gi-rock-golem',
  'gi-rocking-chair',
  'gi-rod-of-asclepius',
  'gi-rolled-cloth',
  'gi-roller-skate',
  'gi-rolling-dice-cup',
  'gi-rolling-dices',
  'gi-roman-shield',
  'gi-roman-toga',
  'gi-rooster',
  'gi-rope-bridge',
  'gi-rope-coil',
  'gi-rope-dart',
  'gi-ropeway',
  'gi-round-knob',
  'gi-round-silo',
  'gi-round-star',
  'gi-round-straw-bale',
  'gi-round-table',
  'gi-rss',
  'gi-rubber-boot',
  'gi-rub-el-hizb',
  'gi-rugby-conversion',
  'gi-rule-book',
  'gi-running-shoe',
  'gi-rupee',
  'gi-rusty-sword',
  'gi-saber-and-pistol',
  'gi-saber-toothed-cat-head',
  'gi-saddle',
  'gi-safety-pin',
  'gi-sagittarius',
  'gi-sai',
  'gi-sail',
  'gi-sailboat',
  'gi-saint-basil-cathedral',
  'gi-saiyan-suit',
  'gi-saloon',
  'gi-saloon-doors',
  'gi-samara-mosque',
  'gi-samurai-helmet',
  'gi-samus-helmet',
  'gi-sandal',
  'gi-sand-castle',
  'gi-sand-snake',
  'gi-sandstorm',
  'gi-sandwich',
  'gi-santa-hat',
  'gi-sarcophagus',
  'gi-sasquatch',
  'gi-satellite-communication',
  'gi-sauropod-head',
  'gi-sausage',
  'gi-sausages-ribbon',
  'gi-save',
  'gi-save-arrow',
  'gi-sawed-off-shotgun',
  'gi-saxophone',
  'gi-s-brick',
  'gi-scabbard',
  'gi-school-bag',
  'gi-school-of-fish',
  'gi-scooter',
  'gi-scorpio',
  'gi-scout-ship',
  'gi-screw',
  'gi-scroll-quill',
  'gi-scuba-mask',
  'gi-scuba-tanks',
  'gi-sea-cliff',
  'gi-seagull',
  'gi-seahorse',
  'gi-sea-star',
  'gi-sea-turtle',
  'gi-secret-book',
  'gi-secret-door',
  'gi-security-gate',
  'gi-seedling',
  'gi-sell-card',
  'gi-sergeant',
  'gi-server-rack',
  'gi-sesame',
  'gi-settings-knobs',
  'gi-seven-pointed-star',
  'gi-sewing-string',
  'gi-sextant',
  'gi-shaking-hands',
  'gi-shambling-mound',
  'gi-shambling-zombie',
  'gi-shamrock',
  'gi-share',
  'gi-shark-bite',
  'gi-shark-fin',
  'gi-sharp-axe',
  'gi-sharp-halberd',
  'gi-shattered-heart',
  'gi-shears',
  'gi-sheep',
  'gi-sherlock-holmes',
  'gi-shield-bash',
  'gi-shield-impact',
  'gi-shield-opposition',
  'gi-shinto-shrine',
  'gi-shinto-shrine-mirror',
  'gi-ship-bow',
  'gi-ship-wheel',
  'gi-ship-wreck',
  'gi-shirt-button',
  'gi-shoebill-stork',
  'gi-shop',
  'gi-shopping-bag',
  'gi-shopping-cart',
  'gi-shorts',
  'gi-shotgun-rounds',
  'gi-shoulder-armor',
  'gi-shoulder-bag',
  'gi-shower',
  'gi-shrimp',
  'gi-shrug',
  'gi-shuttlecock',
  'gi-sickle',
  'gi-siege-tower',
  'gi-silenced',
  'gi-silex',
  'gi-silver-bullet',
  'gi-sinagot',
  'gi-sinking-ship',
  'gi-sitting-dog',
  'gi-skateboard',
  'gi-skeletal-hand',
  'gi-ski-boot',
  'gi-skier',
  'gi-skills',
  'gi-skipping-rope',
  'gi-skirt',
  'gi-skis',
  'gi-skull-staff',
  'gi-slalom',
  'gi-sleeping-bag',
  'gi-sleeveless-jacket',
  'gi-sleeveless-top',
  'gi-sliced-mushroom',
  'gi-sliced-sausage',
  'gi-slime',
  'gi-sling',
  'gi-slingshot',
  'gi-slipknot',
  'gi-slippers',
  'gi-slumbering-sanctuary',
  'gi-smart',
  'gi-smartphone',
  'gi-smoking-pipe',
  'gi-smoking-volcano',
  'gi-snail-eyes',
  'gi-snake-egg',
  'gi-snake-jar',
  'gi-snake-spiral',
  'gi-snake-tongue',
  'gi-sniffing-dog',
  'gi-snitch-quidditch-ball',
  'gi-snowboard',
  'gi-soap',
  'gi-soccer-ball',
  'gi-soccer-field',
  'gi-soccer-kick',
  'gi-socks',
  'gi-sofa',
  'gi-solar-system',
  'gi-solar-time',
  'gi-solid-leaf',
  'gi-sombrero',
  'gi-sonic-shoes',
  'gi-soul-vessel',
  'gi-sound-off',
  'gi-sound-on',
  'gi-south-africa',
  'gi-south-africa-flag',
  'gi-south-america',
  'gi-south-korea',
  'gi-space-needle',
  'gi-spaceship',
  'gi-space-shuttle',
  'gi-spain',
  'gi-sparkles',
  'gi-spark-plug',
  'gi-spartan-helmet',
  'gi-speaker',
  'gi-speaker-off',
  'gi-spear-feather',
  'gi-spearfishing',
  'gi-speed-boat',
  'gi-speedometer',
  'gi-spell-book',
  'gi-sperm-whale',
  'gi-spider-bot',
  'gi-spider-eye',
  'gi-spider-mask',
  'gi-spiked-dragon-head',
  'gi-spiked-shield',
  'gi-spiked-shoulder-armor',
  'gi-spiked-trunk',
  'gi-spiked-wall',
  'gi-spiky-pit',
  'gi-spiky-wing',
  'gi-spiral-hilt',
  'gi-spiral-lollipop',
  'gi-split-arrows',
  'gi-spock-hand',
  'gi-spooky-house',
  'gi-sport-medal',
  'gi-spring',
  'gi-spy',
  'gi-square',
  'gi-squirrel',
  'gi-sri-lanka',
  'gi-stabbed-note',
  'gi-stable',
  'gi-stack',
  'gi-stairs',
  'gi-stairs-cake',
  'gi-stairs-goal',
  'gi-stake-hammer',
  'gi-stakes-fence',
  'gi-stalactites',
  'gi-stamper',
  'gi-star-altar',
  'gi-starfighter',
  'gi-star-flag',
  'gi-star-formation',
  'gi-star-gate',
  'gi-star-key',
  'gi-star-medal',
  'gi-stars-stack',
  'gi-star-struck',
  'gi-steak',
  'gi-stealth-bomber',
  'gi-steam',
  'gi-steam-blast',
  'gi-steam-locomotive',
  'gi-steampunk-goggles',
  'gi-steering-wheel',
  'gi-stegosaurus-scales',
  'gi-stethoscope',
  'gi-stick-frame',
  'gi-sticky-boot',
  'gi-stockpiles',
  'gi-stomach',
  'gi-stone-bridge',
  'gi-stone-bust',
  'gi-stone-path',
  'gi-stone-pile',
  'gi-stone-stack',
  'gi-stone-wall',
  'gi-stone-wheel',
  'gi-stop-sign',
  'gi-stork-delivery',
  'gi-straight-pipe',
  'gi-strawberry',
  'gi-street-light',
  'gi-striped-sun',
  'gi-strongbox',
  'gi-strong-man',
  'gi-stump-regrowth',
  'gi-stun-grenade',
  'gi-submarine',
  'gi-submarine-missile',
  'gi-subway',
  'gi-sugar-cane',
  'gi-suitcase',
  'gi-summits',
  'gi-sun-cloud',
  'gi-sunflower',
  'gi-sunglasses',
  'gi-sun-priest',
  'gi-sunrise',
  'gi-sunset',
  'gi-sun-spear',
  'gi-surf-board',
  'gi-surfer-van',
  'gi-sushis',
  'gi-suspension-bridge',
  'gi-sverd-i-fjell',
  'gi-swallow',
  'gi-swallower',
  'gi-swamp',
  'gi-swamp-bat',
  'gi-swimfins',
  'gi-swipe-card',
  'gi-swiss-army-knife',
  'gi-switch-weapon',
  'gi-switzerland',
  'gi-sword-altar',
  'gi-sword-brandish',
  'gi-sword-mold',
  'gi-swords-power',
  'gi-sydney-opera-house',
  'gi-table',
  'gi-tabletop-players',
  'gi-tacos',
  'gi-tadpole',
  'gi-take-my-money',
  'gi-tall-bridge',
  'gi-tambourine',
  'gi-tangerine',
  'gi-tank-top',
  'gi-tanzania',
  'gi-tap',
  'gi-tapir',
  'gi-target-poster',
  'gi-target-prize',
  'gi-taurus',
  'gi-tavern-sign',
  'gi-t-brick',
  'gi-teacher',
  'gi-team-downgrade',
  'gi-team-idea',
  'gi-team-upgrade',
  'gi-teapot-leaves',
  'gi-tee-pipe',
  'gi-templar-shield',
  'gi-temple-door',
  'gi-temple-gate',
  'gi-temporary-shield',
  'gi-tennis-ball',
  'gi-tennis-court',
  'gi-tennis-racket',
  'gi-tentacles-barrier',
  'gi-texas',
  'gi-theater',
  'gi-theater-curtains',
  'gi-thermometer-cold',
  'gi-thermometer-hot',
  'gi-think',
  'gi-thor-hammer',
  'gi-three-friends',
  'gi-throne-king',
  'gi-throwing-ball',
  'gi-thrust-bend',
  'gi-thumb-down',
  'gi-thumb-up',
  'gi-thwomp',
  'gi-tiara',
  'gi-ticket',
  'gi-tic-tac-toe',
  'gi-tie',
  'gi-tiger',
  'gi-tiger-head',
  'gi-tightrope',
  'gi-time-dynamite',
  'gi-time-synchronization',
  'gi-tipi',
  'gi-tired-eye',
  'gi-tire-iron',
  'gi-tire-iron-cross',
  'gi-tire-tracks',
  'gi-toaster',
  'gi-toggles',
  'gi-token',
  'gi-tomahawk',
  'gi-tomato',
  'gi-tongue',
  'gi-toolbox',
  'gi-torch',
  'gi-torpedo',
  'gi-tortoise',
  'gi-totem',
  'gi-toucan',
  'gi-towel',
  'gi-tower-bridge',
  'gi-tower-flag',
  'gi-tow-truck',
  'gi-toy-mallet',
  'gi-tracked-robot',
  'gi-traffic-cone',
  'gi-traffic-lights-green',
  'gi-traffic-lights-orange',
  'gi-traffic-lights-ready-to-go',
  'gi-traffic-lights-red',
  'gi-trail',
  'gi-transform',
  'gi-trash-can',
  'gi-travel-dress',
  'gi-trebuchet',
  'gi-tree-beehive',
  'gi-tree-door',
  'gi-tree-growth',
  'gi-tree-roots',
  'gi-tree-swing',
  'gi-t-rex-skull',
  'gi-triangle-target',
  'gi-tribal-gear',
  'gi-tribal-pendant',
  'gi-tribal-shield',
  'gi-tribunal-jury',
  'gi-triceratops-head',
  'gi-trident-shield',
  'gi-triforce',
  'gi-trinacria',
  'gi-triple-gate',
  'gi-triquetra',
  'gi-trireme',
  'gi-troglodyte',
  'gi-trojan-horse',
  'gi-trophies-shelf',
  'gi-trophy-cup',
  'gi-tropical-fish',
  'gi-trowel',
  'gi-truce',
  'gi-truck',
  'gi-trumpet',
  'gi-trumpet-flag',
  'gi-trunk-mushroom',
  'gi-t-shirt',
  'gi-tumbleweed',
  'gi-tunisia',
  'gi-turban',
  'gi-turbine',
  'gi-turnstile',
  'gi-tusks-flag',
  'gi-tv',
  'gi-tv-remote',
  'gi-tv-tower',
  'gi-two-coins',
  'gi-two-handed-sword',
  'gi-udder',
  'gi-ufo',
  'gi-uluru',
  'gi-umbrella-bayonet',
  'gi-unbalanced',
  'gi-underground-cave',
  'gi-underwear',
  'gi-underwear-shorts',
  'gi-unicorn',
  'gi-unicycle',
  'gi-union-jack',
  'gi-up-card',
  'gi-upgrade',
  'gi-uprising',
  'gi-ursa-major',
  'gi-uruguay',
  'gi-usa-flag',
  'gi-usb-key',
  'gi-ushanka',
  'gi-uzi',
  'gi-vacuum-cleaner',
  'gi-valve',
  'gi-vampire-cape',
  'gi-vampire-dracula',
  'gi-van-damme-split',
  'gi-velocipede',
  'gi-velociraptor',
  'gi-velociraptor-tracks',
  'gi-vending-machine',
  'gi-venezuela',
  'gi-venus-of-willendorf',
  'gi-vertical-banner',
  'gi-vertical-flip',
  'gi-vibrating-shield',
  'gi-vibrating-smartphone',
  'gi-video-camera',
  'gi-video-conference',
  'gi-viking-church',
  'gi-viking-head',
  'gi-viking-helmet',
  'gi-viking-longhouse',
  'gi-viking-shield',
  'gi-village',
  'gi-vines',
  'gi-virgo',
  'gi-virtual-marker',
  'gi-vitruvian-man',
  'gi-volleyball-ball',
  'gi-vote',
  'gi-vr-headset',
  'gi-vuvuzelas',
  'gi-walk',
  'gi-walkie-talkie',
  'gi-walking-scout',
  'gi-walking-turret',
  'gi-wallet',
  'gi-wall-light',
  'gi-walrus-head',
  'gi-wanted-reward',
  'gi-war-axe',
  'gi-war-bonnet',
  'gi-warhammer',
  'gi-warlock-eye',
  'gi-warlock-hood',
  'gi-war-pick',
  'gi-warp-pipe',
  'gi-washing-machine',
  'gi-watch',
  'gi-watchtower',
  'gi-water-bottle',
  'gi-water-diviner-stick',
  'gi-waterfall',
  'gi-water-flask',
  'gi-water-fountain',
  'gi-water-gallon',
  'gi-water-gun',
  'gi-watering-can',
  'gi-watermelon',
  'gi-water-polo',
  'gi-water-recycling',
  'gi-water-tank',
  'gi-water-tower',
  'gi-wave-surfer',
  'gi-wax-tablet',
  'gi-weight',
  'gi-weight-lifting-down',
  'gi-weight-lifting-up',
  'gi-weight-scale',
  'gi-well',
  'gi-western-hat',
  'gi-whale-tail',
  'gi-wheelbarrow',
  'gi-whisk',
  'gi-whistle',
  'gi-wifi-router',
  'gi-windmill',
  'gi-window',
  'gi-window-bars',
  'gi-windpump',
  'gi-windsock',
  'gi-wind-turbine',
  'gi-wine-bottle',
  'gi-winged-scepter',
  'gi-winter-gloves',
  'gi-winter-hat',
  'gi-wire-coil',
  'gi-wireframe-globe',
  'gi-wisdom',
  'gi-wizard-face',
  'gi-wolverine-claws',
  'gi-woman-elf-face',
  'gi-wood-beam',
  'gi-wood-cabin',
  'gi-wood-canoe',
  'gi-wood-club',
  'gi-wooden-chair',
  'gi-wooden-clogs',
  'gi-wooden-crate',
  'gi-wooden-pegleg',
  'gi-wooden-pier',
  'gi-wood-frame',
  'gi-wood-pile',
  'gi-wood-stick',
  'gi-wool',
  'gi-worms',
  'gi-xylophone',
  'gi-yarn',
  'gi-yin-yang',
  'gi-yunluo',
  'gi-zat-gun',
  'gi-z-brick',
  'gi-zigzag-hieroglyph',
  'gi-zipper',
  'gi-card-discard',
  'gi-card-draw',
  'gi-card-pick',
  'gi-card-random',
  'gi-dragon-head',
  'gi-forward-sun',
  'gi-minerals',
  'gi-nautilus-shell',
  'gi-ninja-star',
  'gi-ore',
  'gi-dodge',
  'gi-overhead',
  'gi-sideswipe',
  'gi-thrust',
  'gi-underhand',
  'gi-fingers-crossed',
  'gi-shepherds-crook',
  'gi-pause-button',
  'gi-play-button',
  'gi-soda-can',
  'gi-catapult',
  'gi-defensive-wall',
  'gi-armored-pants',
  'gi-pistol-gun',
  'gi-paper',
  'gi-rock',
  'gi-scissors',
  'gi-dwarf-helmet',
  'gi-dwarf-king',
  'gi-elf-helmet',
  'gi-ace',
  'gi-acid-blob',
  'gi-acorn',
  'gi-aerial-signal',
  'gi-aerodynamic-harpoon',
  'gi-aerosol',
  'gi-afterburn',
  'gi-air-zigzag',
  'gi-alien-fire',
  'gi-alien-skull',
  'gi-alien-stare',
  'gi-all-for-one',
  'gi-alligator-clip',
  'gi-ammonite',
  'gi-ammonite-fossil',
  'gi-anatomy',
  'gi-anchor',
  'gi-android-mask',
  'gi-andromeda-chain',
  'gi-angel-outfit',
  'gi-angel-wings',
  'gi-angler-fish',
  'gi-angular-spider',
  'gi-animal-skull',
  'gi-ankh',
  'gi-anthem',
  'gi-anvil',
  'gi-anvil-impact',
  'gi-apple-maggot',
  'gi-apple-seeds',
  'gi-archery-target',
  'gi-architect-mask',
  'gi-arcing-bolt',
  'gi-armadillo-tail',
  'gi-armor-vest',
  'gi-armoured-shell',
  'gi-arrow-cluster',
  'gi-arrow-dunk',
  'gi-arrowed',
  'gi-arrow-flights',
  'gi-arrowhead',
  'gi-arrow-scope',
  'gi-arrows-shield',
  'gi-arson',
  'gi-artificial-hive',
  'gi-assassin-pocket',
  'gi-atomic-slashes',
  'gi-at-sea',
  'gi-aubergine',
  'gi-aura',
  'gi-autogun',
  'gi-automatic-sas',
  'gi-auto-repair',
  'gi-awareness',
  'gi-axe-in-stump',
  'gi-axe-swing',
  'gi-backbone-shell',
  'gi-back-forth',
  'gi-back-pain',
  'gi-backstab',
  'gi-backup',
  'gi-ball-glow',
  'gi-ball-heart',
  'gi-balloons',
  'gi-bandaged',
  'gi-bandage-roll',
  'gi-barbed-arrow',
  'gi-barbed-coil',
  'gi-barbed-nails',
  'gi-barbed-spear',
  'gi-barbed-star',
  'gi-barbed-sun',
  'gi-barbed-wire',
  'gi-barbute',
  'gi-barefoot',
  'gi-bat-blade',
  'gi-battered-axe',
  'gi-batteries',
  'gi-battle-axe',
  'gi-battle-gear',
  'gi-battle-tank',
  'gi-bat-wing',
  'gi-batwing-emblem',
  'gi-beams-aura',
  'gi-beam-wake',
  'gi-beanstalk',
  'gi-beard',
  'gi-beast-eye',
  'gi-bee',
  'gi-beech',
  'gi-beer-stein',
  'gi-beetle-shell',
  'gi-behold',
  'gi-bell-shield',
  'gi-belt-buckles',
  'gi-bestial-fangs',
  'gi-beveled-star',
  'gi-big-wave',
  'gi-biohazard',
  'gi-bird-claw',
  'gi-bird-limb',
  'gi-bird-mask',
  'gi-bird-twitter',
  'gi-blackball',
  'gi-black-bar',
  'gi-blackcurrant',
  'gi-black-flag',
  'gi-black-hand-shield',
  'gi-black-hole-bolas',
  'gi-blade-bite',
  'gi-blade-drag',
  'gi-blade-fall',
  'gi-bleeding-eye',
  'gi-bleeding-heart',
  'gi-bleeding-wound',
  'gi-bloody-stash',
  'gi-bloody-sword',
  'gi-blunderbuss',
  'gi-boar-tusks',
  'gi-body-swapping',
  'gi-boiling-bubbles',
  'gi-bolas',
  'gi-bolter-gun',
  'gi-bolt-eye',
  'gi-bolt-saw',
  'gi-bolt-shield',
  'gi-bombing-run',
  'gi-bone-gnawer',
  'gi-bone-knife',
  'gi-book-aura',
  'gi-book-cover',
  'gi-bookmark',
  'gi-bookmarklet',
  'gi-book-storm',
  'gi-boomerang-sun',
  'gi-boot-kick',
  'gi-boot-prints',
  'gi-boots',
  'gi-boot-stomp',
  'gi-bordered-shield',
  'gi-bottled-bolt',
  'gi-bottle-vapors',
  'gi-bottom-right-3d-arrow',
  'gi-bouncing-sword',
  'gi-bowie-knife',
  'gi-bowling-propulsion',
  'gi-bowl-spiral',
  'gi-bowman',
  'gi-boxing-glove',
  'gi-boxing-glove-surprise',
  'gi-brain',
  'gi-brain-freeze',
  'gi-brain-stem',
  'gi-brainstorm',
  'gi-branch-arrow',
  'gi-brandy-bottle',
  'gi-brass-eye',
  'gi-breastplate',
  'gi-bridge',
  'gi-bright-explosion',
  'gi-broad-dagger',
  'gi-broadhead-arrow',
  'gi-broadsword',
  'gi-broken-bone',
  'gi-broken-bottle',
  'gi-broken-heart',
  'gi-broken-heart-zone',
  'gi-broken-ribbon',
  'gi-broken-shield',
  'gi-broken-skull',
  'gi-broken-tablet',
  'gi-bubble-field',
  'gi-bubbles',
  'gi-bubbling-beam',
  'gi-bubbling-bowl',
  'gi-bubbling-flask',
  'gi-bud',
  'gi-bugle-call',
  'gi-bulb',
  'gi-bull',
  'gi-bullets',
  'gi-bull-horns',
  'gi-burning-blobs',
  'gi-burning-book',
  'gi-burning-dot',
  'gi-burning-embers',
  'gi-burning-eye',
  'gi-burning-meteor',
  'gi-burning-passion',
  'gi-burning-round-shot',
  'gi-burning-tree',
  'gi-burst-blob',
  'gi-butterfly',
  'gi-butterfly-warning',
  'gi-caged-ball',
  'gi-cake-slice',
  'gi-caldera',
  'gi-campfire',
  'gi-candlebright',
  'gi-candle-flame',
  'gi-candle-holder',
  'gi-candle-light',
  'gi-candle-skull',
  'gi-cannister',
  'gi-cannon',
  'gi-cannon-ball',
  'gi-cannon-shot',
  'gi-capitol',
  'gi-cargo-crane',
  'gi-carillon',
  'gi-carnivore-mouth',
  'gi-carrion',
  'gi-cartwheel',
  'gi-cash',
  'gi-castle',
  'gi-cat',
  'gi-cauldron',
  'gi-celebration-fire',
  'gi-centipede',
  'gi-chained-arrow-heads',
  'gi-chained-heart',
  'gi-chalice-drops',
  'gi-charged-arrow',
  'gi-charm',
  'gi-checkbox-tree',
  'gi-checked-shield',
  'gi-checkered-diamond',
  'gi-cheerful',
  'gi-cheese-wedge',
  'gi-chemical-arrow',
  'gi-chemical-bolt',
  'gi-chemical-drop',
  'gi-chemical-tank',
  'gi-chewed-heart',
  'gi-chewed-skull',
  'gi-chicken-leg',
  'gi-chopped-skull',
  'gi-circle-cage',
  'gi-circle-claws',
  'gi-circle-sparks',
  'gi-circuitry',
  'gi-circular-sawblade',
  'gi-claw-hammer',
  'gi-claw-slashes',
  'gi-claw-string',
  'gi-cloak-dagger',
  'gi-clockwork',
  'gi-cloud-ring',
  'gi-cloudy-fork',
  'gi-clout',
  'gi-clover',
  'gi-cluster-bomb',
  'gi-cobweb',
  'gi-coffee-mug',
  'gi-coffin',
  'gi-cog',
  'gi-cog-lock',
  'gi-cogsplosion',
  'gi-coiling-curl',
  'gi-cold-heart',
  'gi-coma',
  'gi-comb',
  'gi-comet-spark',
  'gi-compass',
  'gi-concentration-orb',
  'gi-concentric-crescents',
  'gi-condor-emblem',
  'gi-condylura-skull',
  'gi-conversation',
  'gi-cool-spices',
  'gi-corked-tube',
  'gi-corner-explosion',
  'gi-cowled',
  'gi-cpu-shot',
  'gi-crab',
  'gi-crab-claw',
  'gi-cracked-alien-skull',
  'gi-cracked-ball-dunk',
  'gi-cracked-disc',
  'gi-cracked-glass',
  'gi-cracked-helm',
  'gi-cracked-mask',
  'gi-cracked-saber',
  'gi-cracked-shield',
  'gi-crags',
  'gi-crenulated-shield',
  'gi-crescent-blade',
  'gi-crested-helmet',
  'gi-croc-jaws',
  'gi-croc-sword',
  'gi-croissants-pupil',
  'gi-crossed-air-flows',
  'gi-crossed-axes',
  'gi-crossed-bones',
  'gi-crossed-chains',
  'gi-crossed-claws',
  'gi-crossed-pistols',
  'gi-crossed-sabres',
  'gi-crossed-slashes',
  'gi-crossed-swords',
  'gi-cross-flare',
  'gi-crosshair-arrow',
  'gi-cross-mark',
  'gi-crow-dive',
  'gi-crown',
  'gi-crown-coin',
  'gi-crowned-explosion',
  'gi-crowned-heart',
  'gi-crowned-skull',
  'gi-crown-of-thorns',
  'gi-crumbling-ball',
  'gi-crystal-ball',
  'gi-crystal-bars',
  'gi-crystal-cluster',
  'gi-crystal-eye',
  'gi-crystal-growth',
  'gi-crystalize',
  'gi-crystal-shine',
  'gi-crystal-wand',
  'gi-cubeforce',
  'gi-cubes',
  'gi-cultist',
  'gi-cupidon-arrow',
  'gi-curled-leaf',
  'gi-curled-tentacle',
  'gi-curling-vines',
  'gi-curly-mask',
  'gi-curly-wing',
  'gi-cursed-star',
  'gi-curvy-knife',
  'gi-cut-diamond',
  'gi-cut-palm',
  'gi-cycle',
  'gi-cyclops',
  'gi-daemon-skull',
  'gi-daggers',
  'gi-daisy',
  'gi-dark-squad',
  'gi-dead-eye',
  'gi-deadly-strike',
  'gi-dead-wood',
  'gi-deathcab',
  'gi-death-note',
  'gi-death-zone',
  'gi-decapitation',
  'gi-defibrilate',
  'gi-delighted',
  'gi-demolish',
  'gi-dervish-swords',
  'gi-desert-skull',
  'gi-desk-lamp',
  'gi-despair',
  'gi-dew',
  'gi-diablo-skull',
  'gi-diamond-hard',
  'gi-diamonds-smile',
  'gi-dig-dug',
  'gi-dinosaur-bones',
  'gi-dinosaur-egg',
  'gi-dinosaur-rex',
  'gi-direwolf',
  'gi-disc',
  'gi-disintegrate',
  'gi-distraction',
  'gi-divergence',
  'gi-divert',
  'gi-divided-spiral',
  'gi-diving-dagger',
  'gi-dna1',
  'gi-dna2',
  'gi-doctor-face',
  'gi-dodging',
  'gi-domino-mask',
  'gi-doorway',
  'gi-dorsal-scales',
  'gi-double-diaphragm',
  'gi-double-dragon',
  'gi-double-face-mask',
  'gi-double-quaver',
  'gi-double-ringed-orb',
  'gi-double-shot',
  'gi-dove',
  'gi-dozen',
  'gi-dragon-balls',
  'gi-dragon-breath',
  'gi-dragonfly',
  'gi-dragon-head',
  'gi-dragon-spiral',
  'gi-drama-masks',
  'gi-dread-skull',
  'gi-drill',
  'gi-drink-me',
  'gi-dripping-blade',
  'gi-dripping-goo',
  'gi-dripping-honey',
  'gi-dripping-knife',
  'gi-dripping-star',
  'gi-dripping-stone',
  'gi-dripping-sword',
  'gi-dripping-tube',
  'gi-drop',
  'gi-droplets',
  'gi-droplet-splash',
  'gi-drowning',
  'gi-duality',
  'gi-duality-mask',
  'gi-dust-cloud',
  'gi-eagle-emblem',
  'gi-earth-crack',
  'gi-earth-spit',
  'gi-earwig',
  'gi-echo-ripples',
  'gi-eclipse',
  'gi-eclipse-flare',
  'gi-eclipse-saw',
  'gi-edge-crack',
  'gi-edged-shield',
  'gi-egg-clutch',
  'gi-egg-defense',
  'gi-elderberry',
  'gi-electrical-crescent',
  'gi-electric-whip',
  'gi-ember-shot',
  'gi-embrassed-energy',
  'gi-embryo',
  'gi-emerald',
  'gi-empty-hourglass',
  'gi-energise',
  'gi-energy-arrow',
  'gi-energy-breath',
  'gi-energy-shield',
  'gi-energy-sword',
  'gi-engagement-ring',
  'gi-enlightenment',
  'gi-entangled-typhoon',
  'gi-ent-mouth',
  'gi-envelope',
  'gi-erlenmeyer',
  'gi-eruption',
  'gi-eskimo',
  'gi-evil-bat',
  'gi-evil-book',
  'gi-evil-bud',
  'gi-evil-comet',
  'gi-evil-fork',
  'gi-evil-hand',
  'gi-evil-minion',
  'gi-evil-moon',
  'gi-evil-tree',
  'gi-expanded-rays',
  'gi-explosion-rays',
  'gi-explosive-materials',
  'gi-explosive-meeting',
  'gi-extraction-orb',
  'gi-extra-lucid',
  'gi-eyeball',
  'gi-eyedropper',
  'gi-eye-shield',
  'gi-eyestalk',
  'gi-fairy',
  'gi-fairy-wand',
  'gi-falling-blob',
  'gi-falling-boulder',
  'gi-falling-eye',
  'gi-falling-leaf',
  'gi-falling-ovoid',
  'gi-fanged-skull',
  'gi-fangs-circle',
  'gi-fast-arrow',
  'gi-feather',
  'gi-feathered-wing',
  'gi-feather-wound',
  'gi-fedora',
  'gi-field',
  'gi-fire-ace',
  'gi-fire-axe',
  'gi-fireball',
  'gi-fire-bomb',
  'gi-fire-bottle',
  'gi-fire-bowl',
  'gi-fire-breath',
  'gi-fire-dash',
  'gi-fire-punch',
  'gi-fire-ray',
  'gi-fire-ring',
  'gi-fire-shield',
  'gi-fire-silhouette',
  'gi-fire-tail',
  'gi-fire-wave',
  'gi-firework-rocket',
  'gi-fire-zone',
  'gi-fishbone',
  'gi-fish-corpse',
  'gi-fishhook-fork',
  'gi-fishing-hook',
  'gi-fishing-net',
  'gi-fission',
  'gi-fist',
  'gi-fizzing-flask',
  'gi-flame-claws',
  'gi-flamed-leaf',
  'gi-flame-spin',
  'gi-flame-tunnel',
  'gi-flaming-arrow',
  'gi-flaming-claw',
  'gi-flaming-sheet',
  'gi-flaming-trident',
  'gi-flash-grenade',
  'gi-flat-hammer',
  'gi-flat-paw-print',
  'gi-flat-star',
  'gi-fleshy-mass',
  'gi-flexible-star',
  'gi-floating-crystal',
  'gi-flower-pot',
  'gi-flowers',
  'gi-flower-twirl',
  'gi-fluffy-cloud',
  'gi-fluffy-flame',
  'gi-fluffy-swirl',
  'gi-fluffy-trefoil',
  'gi-fluffy-wing',
  'gi-flying-dagger',
  'gi-flying-flag',
  'gi-foam',
  'gi-foamy-disc',
  'gi-focused-lightning',
  'gi-folded-paper',
  'gi-food-chain',
  'gi-footprint',
  'gi-foot-trip',
  'gi-forward-field',
  'gi-fossil',
  'gi-fountain',
  'gi-fountain-pen',
  'gi-fox-head',
  'gi-fragmented-meteor',
  'gi-fragmented-sword',
  'gi-fragrance',
  'gi-frankenstein-creature',
  'gi-frayed-arrow',
  'gi-freedom-dove',
  'gi-frog',
  'gi-frontal-lobe',
  'gi-front-teeth',
  'gi-frostfire',
  'gi-frozen-arrow',
  'gi-frozen-block',
  'gi-frozen-orb',
  'gi-fruiting',
  'gi-fulguro-punch',
  'gi-galleon',
  'gi-gamepad-cross',
  'gi-gas-mask',
  'gi-gavel',
  'gi-gaze',
  'gi-gear-hammer',
  'gi-gears',
  'gi-gecko',
  'gi-gem-chain',
  'gi-gem-necklace',
  'gi-gem-pendant',
  'gi-gems',
  'gi-ghost',
  'gi-ghost-ally',
  'gi-gibbet',
  'gi-gift-of-knowledge',
  'gi-gift-trap',
  'gi-glass-heart',
  'gi-glass-shot',
  'gi-globe',
  'gi-gloop',
  'gi-glowing-hands',
  'gi-gluttonous-smile',
  'gi-gluttony',
  'gi-gold-scarab',
  'gi-gold-shell',
  'gi-goo-explosion',
  'gi-gooey-daemon',
  'gi-gooey-eyed-sun',
  'gi-gooey-impact',
  'gi-gooey-molecule',
  'gi-gooey-sword',
  'gi-goo-skull',
  'gi-goo-spurt',
  'gi-gothic-cross',
  'gi-grab',
  'gi-grapes',
  'gi-grapple',
  'gi-grasping-claws',
  'gi-grease-trap',
  'gi-grenade',
  'gi-grim-reaper',
  'gi-groundbreaker',
  'gi-ground-sprout',
  'gi-grouped-drops',
  'gi-guarded-tower',
  'gi-guillotine',
  'gi-guitar',
  'gi-gunshot',
  'gi-halberd',
  'gi-halberd-shuriken',
  'gi-half-heart',
  'gi-half-tornado',
  'gi-hammer-drop',
  'gi-hammer-nails',
  'gi-hand',
  'gi-handcuffs',
  'gi-hanging-spider',
  'gi-happy-skull',
  'gi-harpoon-chain',
  'gi-harpoon-trident',
  'gi-harpy',
  'gi-harry-potter-skull',
  'gi-hatchets',
  'gi-haunting',
  'gi-hawk-emblem',
  'gi-hazard-sign',
  'gi-headshot',
  'gi-heart-bottle',
  'gi-heartburn',
  'gi-heart-drop',
  'gi-heart-inside',
  'gi-heart-organ',
  'gi-heart-tower',
  'gi-heat-haze',
  'gi-heavy-arrow',
  'gi-heavy-fall',
  'gi-heavy-helm',
  'gi-heavy-lightning',
  'gi-heavy-rain',
  'gi-heavy-thorny-triskelion',
  'gi-heavy-timer',
  'gi-helmet-head-shot',
  'gi-hidden',
  'gi-high-five',
  'gi-high-shot',
  'gi-hollow-cat',
  'gi-holy-grail',
  'gi-holy-symbol',
  'gi-honeycomb',
  'gi-honeypot',
  'gi-hood',
  'gi-hoof',
  'gi-horned-helm',
  'gi-horned-skull',
  'gi-horn-internal',
  'gi-horse-head',
  'gi-hospital-cross',
  'gi-hot-spices',
  'gi-hound',
  'gi-hourglass',
  'gi-hunting-horn',
  'gi-hydra',
  'gi-hydra-shot',
  'gi-hypersonic-bolt',
  'gi-hypersonic-melon',
  'gi-hypodermic-test',
  'gi-icebergs',
  'gi-ice-bolt',
  'gi-ice-bomb',
  'gi-ice-cube',
  'gi-ice-shield',
  'gi-ice-spear',
  'gi-icicles-aura',
  'gi-icicles-fence',
  'gi-ifrit',
  'gi-imbricated-arrows',
  'gi-imp',
  'gi-impact-point',
  'gi-imp-laugh',
  'gi-implosion',
  'gi-imprisoned',
  'gi-incense',
  'gi-incisors',
  'gi-incoming-rocket',
  'gi-infested-mass',
  'gi-ink-swirl',
  'gi-inner-self',
  'gi-insect-jaws',
  'gi-interdiction',
  'gi-interlaced-tentacles',
  'gi-interleaved-arrows',
  'gi-interleaved-claws',
  'gi-internal-injury',
  'gi-internal-organ',
  'gi-interstellar-path',
  'gi-ion-cannon-blast',
  'gi-iron-mask',
  'gi-james-bond-aperture',
  'gi-jawbone',
  'gi-jellyfish',
  'gi-jetpack',
  'gi-jeweled-chalice',
  'gi-jigsaw-box',
  'gi-jigsaw-piece',
  'gi-journey',
  'gi-juggler',
  'gi-justice-star',
  'gi-kaleidoscope-pearls',
  'gi-key',
  'gi-kindle',
  'gi-king',
  'gi-kitchen-knives',
  'gi-knapsack',
  'gi-knife-fork',
  'gi-knife-thrust',
  'gi-lamellar',
  'gi-lamprey-mouth',
  'gi-land-mine',
  'gi-lantern',
  'gi-lantern-flame',
  'gi-large-wound',
  'gi-laser-blast',
  'gi-laserburn',
  'gi-laser-precision',
  'gi-laser-sparks',
  'gi-laser-warning',
  'gi-laurel-crown',
  'gi-laurels',
  'gi-law-star',
  'gi-layered-armor',
  'gi-leaf-skeleton',
  'gi-leaf-swirl',
  'gi-leaky-skull',
  'gi-leather-boot',
  'gi-leather-vest',
  'gi-leeching-worm',
  'gi-letter-bomb',
  'gi-lever',
  'gi-life-in-the-balance',
  'gi-life-support',
  'gi-life-tap',
  'gi-lift',
  'gi-light-bulb',
  'gi-lightning-arc',
  'gi-lightning-bow',
  'gi-lightning-branches',
  'gi-lightning-dissipation',
  'gi-lightning-electron',
  'gi-lightning-frequency',
  'gi-lightning-helix',
  'gi-lightning-mask',
  'gi-lightning-saber',
  'gi-lightning-shadow',
  'gi-lightning-shield',
  'gi-lightning-shout',
  'gi-lightning-slashes',
  'gi-lightning-spanner',
  'gi-lightning-storm',
  'gi-lightning-tear',
  'gi-lightning-tree',
  'gi-lightning-trio',
  'gi-light-thorny-triskelion',
  'gi-linden-leaf',
  'gi-linked-rings',
  'gi-lion',
  'gi-lips',
  'gi-lit-candelabra',
  'gi-lizardman',
  'gi-lizard-tongue',
  'gi-lob-arrow',
  'gi-locked-chest',
  'gi-locked-fortress',
  'gi-long-antennae-bug',
  'gi-lotus',
  'gi-lotus-flower',
  'gi-love-howl',
  'gi-love-injection',
  'gi-love-song',
  'gi-lyre',
  'gi-mace-head',
  'gi-machete',
  'gi-mad-scientist',
  'gi-maggot',
  'gi-magic-gate',
  'gi-magic-lamp',
  'gi-magic-palm',
  'gi-magic-portal',
  'gi-magic-shield',
  'gi-magic-swirl',
  'gi-magnet',
  'gi-magnet-blast',
  'gi-magnifying-glass',
  'gi-mailed-fist',
  'gi-mail-shirt',
  'gi-manacles',
  'gi-mantrap',
  'gi-maple-leaf',
  'gi-marrow-drain',
  'gi-martini',
  'gi-masked-spider',
  'gi-master-of-arms',
  'gi-match-head',
  'gi-match-tip',
  'gi-materials-science',
  'gi-maze',
  'gi-maze-cornea',
  'gi-maze-saw',
  'gi-meat',
  'gi-meat-cleaver',
  'gi-meat-hook',
  'gi-mechanical-arm',
  'gi-medal',
  'gi-medal-skull',
  'gi-meditation',
  'gi-megabot',
  'gi-mesh-ball',
  'gi-metal-bar',
  'gi-metal-disc',
  'gi-metal-hand',
  'gi-metal-scales',
  'gi-meteor-impact',
  'gi-microchip',
  'gi-microscope-lens',
  'gi-middle-arrow',
  'gi-midnight-claw',
  'gi-mighty-spanner',
  'gi-mine-explosion',
  'gi-mineral-heart',
  'gi-minigun',
  'gi-mining',
  'gi-minions',
  'gi-minotaur',
  'gi-miracle-medecine',
  'gi-mirror-mirror',
  'gi-missile-mech',
  'gi-missile-pod',
  'gi-missile-swarm',
  'gi-mite',
  'gi-moebius-star',
  'gi-moebius-trefoil',
  'gi-moebius-triangle',
  'gi-molecule',
  'gi-molotov',
  'gi-monkey',
  'gi-monster-grasp',
  'gi-moon',
  'gi-moon-claws',
  'gi-morbid-humour',
  'gi-mountains',
  'gi-mountaintop',
  'gi-mouse',
  'gi-mouth-watering',
  'gi-movement-sensor',
  'gi-mucous-pillar',
  'gi-muscle-fat',
  'gi-muscle-up',
  'gi-mushroom',
  'gi-mushroom-cloud',
  'gi-mushroom-gills',
  'gi-music-spell',
  'gi-nailed-foot',
  'gi-nailed-head',
  'gi-nails',
  'gi-needle-drill',
  'gi-needle-jaws',
  'gi-nested-eclipses',
  'gi-new-shoot',
  'gi-night-sky',
  'gi-ninja-mask',
  'gi-noodle-ball',
  'gi-nothing-to-say',
  'gi-oak',
  'gi-oat',
  'gi-octogonal-eye',
  'gi-octoman',
  'gi-octopus',
  'gi-oily-spiral',
  'gi-omega',
  'gi-one-eyed',
  'gi-on-target',
  'gi-open-book',
  'gi-opening-shell',
  'gi-open-wound',
  'gi-oppression',
  'gi-orb-direction',
  'gi-orbital',
  'gi-orbital-rays',
  'gi-ouroboros',
  'gi-overdose',
  'gi-overdrive',
  'gi-over-infinity',
  'gi-owl',
  'gi-padlock',
  'gi-palm',
  'gi-paper-arrow',
  'gi-paper-bomb',
  'gi-paper-lantern',
  'gi-papers',
  'gi-parachute',
  'gi-paranoia',
  'gi-parmecia',
  'gi-parrot-head',
  'gi-paw',
  'gi-paw-front',
  'gi-paw-heart',
  'gi-pawn',
  'gi-paw-print',
  'gi-peaks',
  'gi-pentagram-rose',
  'gi-pentarrows-tornado',
  'gi-perfume-bottle',
  'gi-perpendicular-rings',
  'gi-piece-skull',
  'gi-pierced-body',
  'gi-pierced-heart',
  'gi-piercing-sword',
  'gi-pie-slice',
  'gi-pig-face',
  'gi-pill',
  'gi-pill-drop',
  'gi-pincers',
  'gi-pine-tree',
  'gi-pirate-grave',
  'gi-pirate-skull',
  'gi-pizza-cutter',
  'gi-plain-dagger',
  'gi-plasma-bolt',
  'gi-plastron',
  'gi-plate-claw',
  'gi-pocket-bow',
  'gi-pointing',
  'gi-pointy-hat',
  'gi-pointy-sword',
  'gi-poison-bottle',
  'gi-poison-gas',
  'gi-pokecog',
  'gi-poker-hand',
  'gi-pollen-dust',
  'gi-portal',
  'gi-portculis',
  'gi-potion-ball',
  'gi-pouring-chalice',
  'gi-powder',
  'gi-power-lightning',
  'gi-prayer',
  'gi-pretty-fangs',
  'gi-processor',
  'gi-profit',
  'gi-psychic-waves',
  'gi-pummeled',
  'gi-pumpkin-lantern',
  'gi-pumpkin-mask',
  'gi-punch',
  'gi-punch-blast',
  'gi-puppet',
  'gi-pyromaniac',
  'gi-quake-stomp',
  'gi-queen-crown',
  'gi-quicksand',
  'gi-quick-slash',
  'gi-quill',
  'gi-quill-ink',
  'gi-radar-dish',
  'gi-radar-sweep',
  'gi-radial-balance',
  'gi-radioactive',
  'gi-ragged-wound',
  'gi-rainbow-star',
  'gi-raining',
  'gi-rally-the-troops',
  'gi-ram',
  'gi-rapidshare-arrow',
  'gi-raven',
  'gi-ray-gun',
  'gi-razor-blade',
  'gi-reaper-scythe',
  'gi-rear-aura',
  'gi-recycle',
  'gi-relationship-bounds',
  'gi-relic-blade',
  'gi-resonance',
  'gi-reticule',
  'gi-return-arrow',
  'gi-ribbon',
  'gi-ribcage',
  'gi-ringed-beam',
  'gi-ringed-planet',
  'gi-ringing-bell',
  'gi-riot-shield',
  'gi-roast-chicken',
  'gi-robe',
  'gi-robot-golem',
  'gi-rock',
  'gi-rocket',
  'gi-rocket-flight',
  'gi-rogue',
  'gi-rolling-bomb',
  'gi-rolling-energy',
  'gi-root-tip',
  'gi-rosa-shield',
  'gi-rose',
  'gi-rough-wound',
  'gi-round-bottom-flask',
  'gi-round-struck',
  'gi-royal-love',
  'gi-rss',
  'gi-run',
  'gi-rune-stone',
  'gi-rune-sword',
  'gi-sabers-choc',
  'gi-saber-slash',
  'gi-saber-tooth',
  'gi-sacrificial-dagger',
  'gi-sad-crab',
  'gi-salamander',
  'gi-salt-shaker',
  'gi-sands-of-time',
  'gi-saphir',
  'gi-sattelite',
  'gi-saw-claw',
  'gi-scale-mail',
  'gi-scales',
  'gi-scallop',
  'gi-scalpel',
  'gi-scalpel-strike',
  'gi-scarab-beetle',
  'gi-scarecrow',
  'gi-scar-wound',
  'gi-scissors',
  'gi-scorpion',
  'gi-scorpion-tail',
  'gi-screaming',
  'gi-screen-impact',
  'gi-screw',
  'gi-screwdriver',
  'gi-scroll-unfurled',
  'gi-scythe',
  'gi-sea-dragon',
  'gi-sea-serpent',
  'gi-seated-mouse',
  'gi-self-love',
  'gi-semi-closed-eye',
  'gi-sensuousness',
  'gi-sentry-gun',
  'gi-serrated-slash',
  'gi-sewed-shell',
  'gi-sewing-needle',
  'gi-shadow-follower',
  'gi-shadow-grasp',
  'gi-shard-sword',
  'gi-shark-jaws',
  'gi-sharp-crown',
  'gi-sharped-teeth-skull',
  'gi-sharp-lips',
  'gi-sharp-smile',
  'gi-shatter',
  'gi-shattered-glass',
  'gi-shattered-sword',
  'gi-sheikah-eye',
  'gi-shield-bounces',
  'gi-shieldcomb',
  'gi-shield-echoes',
  'gi-shield-reflect',
  'gi-shining-claw',
  'gi-shining-heart',
  'gi-shining-sword',
  'gi-shiny-apple',
  'gi-shiny-entrance',
  'gi-shiny-iris',
  'gi-shiny-omega',
  'gi-shiny-purse',
  'gi-shoulder-scales',
  'gi-shouting',
  'gi-shuriken',
  'gi-shuriken-aperture',
  'gi-shut-rose',
  'gi-silence',
  'gi-sing',
  'gi-sinking-trap',
  'gi-sinusoidal-beam',
  'gi-six-eyes',
  'gi-skeleton-inside',
  'gi-skeleton-key',
  'gi-skid-mark',
  'gi-skull-bolt',
  'gi-skull-crack',
  'gi-skull-crossed-bones',
  'gi-skull-in-jar',
  'gi-skull-mask',
  'gi-skull-ring',
  'gi-skull-shield',
  'gi-skull-signet',
  'gi-skull-slices',
  'gi-slap',
  'gi-slashed-shield',
  'gi-slavery-whip',
  'gi-sleepy',
  'gi-sliced-bread',
  'gi-slicing-arrow',
  'gi-sly',
  'gi-small-fire',
  'gi-smash-arrows',
  'gi-smitten',
  'gi-smoking-finger',
  'gi-smoking-orb',
  'gi-snail',
  'gi-snake',
  'gi-snake-bite',
  'gi-snake-totem',
  'gi-snatch',
  'gi-snout',
  'gi-snow-bottle',
  'gi-snowflake-1',
  'gi-snowflake-2',
  'gi-snowing',
  'gi-snowman',
  'gi-soap-experiment',
  'gi-sonic-boom',
  'gi-sonic-lightning',
  'gi-sonic-screech',
  'gi-sonic-shout',
  'gi-space-suit',
  'gi-spade',
  'gi-spade-skull',
  'gi-spanner',
  'gi-sparkling-sabre',
  'gi-spark-spirit',
  'gi-sparky-bomb',
  'gi-sparrow',
  'gi-spartan',
  'gi-spatter',
  'gi-spear-hook',
  'gi-spears',
  'gi-spectacle-lenses',
  'gi-spectacles',
  'gi-spectre',
  'gi-spider-web',
  'gi-spiked-armor',
  'gi-spiked-collar',
  'gi-spiked-fence',
  'gi-spiked-halo',
  'gi-spiked-mace',
  'gi-spiked-shell',
  'gi-spiked-snail',
  'gi-spiked-tail',
  'gi-spiked-tentacle',
  'gi-spiky-eclipse',
  'gi-spiky-explosion',
  'gi-spiky-field',
  'gi-spill',
  'gi-spinal-coil',
  'gi-spine-arrow',
  'gi-spinning-blades',
  'gi-spinning-ribbons',
  'gi-spinning-sword',
  'gi-spiral-arrow',
  'gi-spiral-bloom',
  'gi-spiral-bottle',
  'gi-spiral-shell',
  'gi-spiral-tentacle',
  'gi-spiral-thrust',
  'gi-splash',
  'gi-splashy-stream',
  'gi-split-body',
  'gi-split-cross',
  'gi-splurt',
  'gi-spoon',
  'gi-spoted-flower',
  'gi-spotted-arrowhead',
  'gi-spotted-mushroom',
  'gi-spotted-wound',
  'gi-spoutnik',
  'gi-spray',
  'gi-sprint',
  'gi-sprout',
  'gi-sprout-disc',
  'gi-spyglass',
  'gi-square-bottle',
  'gi-squib',
  'gi-squid',
  'gi-squid-head',
  'gi-stag-head',
  'gi-stalagtite',
  'gi-standing-potion',
  'gi-star-cycle',
  'gi-star-prominences',
  'gi-star-pupil',
  'gi-star-sattelites',
  'gi-star-skull',
  'gi-star-swirl',
  'gi-staryu',
  'gi-static',
  'gi-static-guard',
  'gi-static-waves',
  'gi-steel-claws',
  'gi-steeltoe-boots',
  'gi-steelwing-emblem',
  'gi-sticking-plaster',
  'gi-stick-splitting',
  'gi-stigmata',
  'gi-stiletto',
  'gi-stitched-wound',
  'gi-stomp',
  'gi-stomp-tornado',
  'gi-stone-axe',
  'gi-stone-block',
  'gi-stone-crafting',
  'gi-stoned-skull',
  'gi-stone-spear',
  'gi-stone-sphere',
  'gi-stone-tablet',
  'gi-stone-throne',
  'gi-stone-tower',
  'gi-stopwatch',
  'gi-strafe',
  'gi-striking-arrows',
  'gi-striking-balls',
  'gi-striking-clamps',
  'gi-striking-diamonds',
  'gi-striking-splinter',
  'gi-striped-sword',
  'gi-strong',
  'gi-suckered-tentacle',
  'gi-suits',
  'gi-sun',
  'gi-sunbeams',
  'gi-sundial',
  'gi-sunken-eye',
  'gi-sun-radiations',
  'gi-sunrise',
  'gi-super-mushroom',
  'gi-supersonic-arrow',
  'gi-supersonic-bullet',
  'gi-surprised',
  'gi-surprised-skull',
  'gi-surrounded-eye',
  'gi-surrounded-shield',
  'gi-suspicious',
  'gi-swallow',
  'gi-swan',
  'gi-swan-breeze',
  'gi-swap-bag',
  'gi-swirl-ring',
  'gi-swirl-string',
  'gi-sword-array',
  'gi-sword-break',
  'gi-sword-clash',
  'gi-sword-hilt',
  'gi-sword-in-stone',
  'gi-swords-emblem',
  'gi-sword-slice',
  'gi-sword-smithing',
  'gi-sword-spade',
  'gi-sword-spin',
  'gi-sword-tie',
  'gi-sword-wound',
  'gi-syringe',
  'gi-tank',
  'gi-target-arrows',
  'gi-target-dummy',
  'gi-targeting',
  'gi-target-shot',
  'gi-tattered-banner',
  'gi-teapot',
  'gi-tearing',
  'gi-tear-tracks',
  'gi-techno-heart',
  'gi-telepathy',
  'gi-teleport',
  'gi-templar-eye',
  'gi-templar-heart',
  'gi-temptation',
  'gi-tension-snowflake',
  'gi-tentacle-heart',
  'gi-tentacles-skull',
  'gi-tentacle-strike',
  'gi-tentacurl',
  'gi-terror',
  'gi-tesla-coil',
  'gi-tesla-turret',
  'gi-test-tubes',
  'gi-thermometer-scale',
  'gi-third-eye',
  'gi-thor-fist',
  'gi-thorned-arrow',
  'gi-thorn-helix',
  'gi-thorny-tentacle',
  'gi-thorny-vine',
  'gi-three-burning-balls',
  'gi-three-keys',
  'gi-three-leaves',
  'gi-thrown-charcoal',
  'gi-thrown-daggers',
  'gi-thrown-knife',
  'gi-thrown-spear',
  'gi-thunderball',
  'gi-thunder-blade',
  'gi-thunder-skull',
  'gi-thunder-struck',
  'gi-tick',
  'gi-tied-scroll',
  'gi-time-bomb',
  'gi-time-trap',
  'gi-tinker',
  'gi-toad-teeth',
  'gi-tombstone',
  'gi-tooth',
  'gi-top-hat',
  'gi-top-paw',
  'gi-tornado',
  'gi-tornado-discs',
  'gi-totem-head',
  'gi-totem-mask',
  'gi-tower-fall',
  'gi-trade',
  'gi-transfuse',
  'gi-transparent-tubes',
  'gi-transportation-rings',
  'gi-trap-mask',
  'gi-tread',
  'gi-treasure-map',
  'gi-tree-branch',
  'gi-trefoil-lily',
  'gi-trefoil-shuriken',
  'gi-tribal-mask',
  'gi-trident',
  'gi-trilobite',
  'gi-triorb',
  'gi-triple-beak',
  'gi-triple-claws',
  'gi-triple-corn',
  'gi-triple-lock',
  'gi-triple-needle',
  'gi-triple-plier',
  'gi-triple-scratches',
  'gi-triple-shells',
  'gi-triple-skulls',
  'gi-triple-yin',
  'gi-tripwire',
  'gi-triton-head',
  'gi-tron-arrow',
  'gi-trophy',
  'gi-trousers',
  'gi-tumor',
  'gi-tune-pitch',
  'gi-turd',
  'gi-turtle',
  'gi-turtle-shell',
  'gi-twin-shell',
  'gi-twirl-center',
  'gi-twirly-flower',
  'gi-twister',
  'gi-two-feathers',
  'gi-two-shadows',
  'gi-tyre',
  'gi-ubisoft-sun',
  'gi-ultrasound',
  'gi-umbrella',
  'gi-uncertainty',
  'gi-unfriendly-fire',
  'gi-unlit-bomb',
  'gi-unlit-candelabra',
  'gi-unlocking',
  'gi-unstable-orb',
  'gi-unstable-projectile',
  'gi-valley',
  'gi-vanilla-flower',
  'gi-vibrating-ball',
  'gi-vile-fluid',
  'gi-vine-flower',
  'gi-vine-leaf',
  'gi-vine-whip',
  'gi-vintage-robot',
  'gi-viola',
  'gi-virus',
  'gi-visored-helm',
  'gi-volcano',
  'gi-vomiting',
  'gi-voodoo-doll',
  'gi-vortex',
  'gi-vulture',
  'gi-walking-boot',
  'gi-wasp-sting',
  'gi-water-bolt',
  'gi-water-splash',
  'gi-wave-crest',
  'gi-waves',
  'gi-wave-strike',
  'gi-wavy-chains',
  'gi-wavy-itinerary',
  'gi-wax-seal',
  'gi-web-spit',
  'gi-werewolf',
  'gi-wheat',
  'gi-whip',
  'gi-whiplash',
  'gi-whirlwind',
  'gi-white-tower',
  'gi-wide-arrow-dunk',
  'gi-wildfires',
  'gi-william-tell',
  'gi-william-tell-skull',
  'gi-wind-hole',
  'gi-wind-slap',
  'gi-windy-stripes',
  'gi-wine-glass',
  'gi-wing-cloak',
  'gi-winged-arrow',
  'gi-winged-emblem',
  'gi-winged-leg',
  'gi-winged-shield',
  'gi-winged-sword',
  'gi-wingfoot',
  'gi-witch-flight',
  'gi-wizard-staff',
  'gi-wolf-head',
  'gi-wolf-howl',
  'gi-wolf-trap',
  'gi-wolverine-claws',
  'gi-wood-axe',
  'gi-wooden-door',
  'gi-wooden-fence',
  'gi-wooden-sign',
  'gi-world',
  'gi-worm-mouth',
  'gi-worried-eyes',
  'gi-wrapped-heart',
  'gi-wrapped-sweet',
  'gi-wrapping-star',
  'gi-wrecking-ball',
  'gi-wyvern',
  'gi-zebra-shield',
  'gi-zeus-sword',
  'gi-zig-arrow',
  'gi-zigzag-cage',
  'gi-zigzag-leaf',
  'gi-zigzag-tune',
  'gi-amplitude',
  'gi-artificial-intelligence',
  'gi-bomber',
  'gi-computing',
  'gi-diagram',
  'gi-heavy-fighter',
  'gi-holosphere',
  'gi-light-fighter',
  'gi-microscope',
  'gi-power-button',
  'gi-belt',
  'gi-cloak',
  'gi-necklace',
  'gi-shirt',
  'gi-trousers',
  'gi-elven-castle',
  'gi-anti-aircraft-gun',
  'gi-shooner-sailboat',
  'gi-small-fishing-sailboat',
  'gi-battery-0',
  'gi-battery-100',
  'gi-battery-25',
  'gi-battery-50',
  'gi-battery-75',
  'gi-battery-minus',
  'gi-battery-plus',
  'gi-artillery-shell',
  'gi-biplane',
  'gi-bunker',
  'gi-bunker-assault',
  'gi-card-pickup',
  'gi-card-play',
  'gi-damaged-house',
  'gi-field-gun',
  'gi-lost-limb',
  'gi-military-ambulance',
  'gi-poppy',
  'gi-trench-assault',
  'gi-chocolate-bar',
  'gi-milk-carton',
  'gi-peanut',
  'gi-acid',
  'gi-acid-tube',
  'gi-ammo-box',
  'gi-arena',
  'gi-battery-pack',
  'gi-battery-pack-alt',
  'gi-big-egg',
  'gi-blast',
  'gi-blaster',
  'gi-burn',
  'gi-cancel',
  'gi-chaingun',
  'gi-circular-saw',
  'gi-claw',
  'gi-clover',
  'gi-clover-spiked',
  'gi-crush',
  'gi-death-skull',
  'gi-doubled',
  'gi-duel',
  'gi-egg-pod',
  'gi-electric',
  'gi-evil-wings',
  'gi-expander',
  'gi-fall-down',
  'gi-falling',
  'gi-fire',
  'gi-fireflake',
  'gi-flake',
  'gi-flamer',
  'gi-grenade',
  'gi-hand',
  'gi-head-shot',
  'gi-health-decrease',
  'gi-health-increase',
  'gi-health-normal',
  'gi-helmet',
  'gi-help',
  'gi-hive',
  'gi-hot-surface',
  'gi-jet-pack',
  'gi-kevlar',
  'gi-key',
  'gi-laser-gun',
  'gi-lava',
  'gi-level-four',
  'gi-level-four-advanced',
  'gi-level-three',
  'gi-level-three-advanced',
  'gi-level-two',
  'gi-level-two-advanced',
  'gi-lucifer-cannon',
  'gi-mass-driver',
  'gi-medical-pack',
  'gi-medical-pack-alt',
  'gi-nodular',
  'gi-nuclear',
  'gi-overkill',
  'gi-overmind',
  'gi-poison',
  'gi-poison-cloud',
  'gi-pounce',
  'gi-pulse',
  'gi-reactor',
  'gi-regeneration',
  'gi-revolt',
  'gi-rifle',
  'gi-select',
  'gi-shield',
  'gi-shotgun',
  'gi-slow-blob',
  'gi-snorkel',
  'gi-spawn-node',
  'gi-spikeball',
  'gi-spikes',
  'gi-spikes-full',
  'gi-spikes-half',
  'gi-spikes-init',
  'gi-splash',
  'gi-suicide',
  'gi-syringe',
  'gi-targeted',
  'gi-target-laser',
  'gi-telefrag',
  'gi-tesla',
  'gi-tombstone',
  'gi-trample',
  'gi-trigger-hurt',
  'gi-turret',
  'gi-unplugged',
  'gi-usable',
  'gi-vial',
  'gi-water-drop',
  'gi-weight-crush',
  'gi-wrench',
  'gi-achievement',
  'gi-air-force',
  'gi-airplane',
  'gi-ak47',
  'gi-ak47u',
  'gi-allied-star',
  'gi-amethyst',
  'gi-amputation',
  'gi-apc',
  'gi-atom',
  'gi-balaclava',
  'gi-balkenkreuz',
  'gi-ballista',
  'gi-bat',
  'gi-baton',
  'gi-bayonet',
  'gi-big-diamond-ring',
  'gi-blood',
  'gi-bowie-knife',
  'gi-box-trap',
  'gi-bracers',
  'gi-breaking-chain',
  'gi-brodie-helmet',
  'gi-bullseye',
  'gi-bundle-grenade',
  'gi-burning-skull',
  'gi-butterfly-knife',
  'gi-c96',
  'gi-carpet-bombing',
  'gi-cement-shoes',
  'gi-chess-bishop',
  'gi-chess-king',
  'gi-chess-knight',
  'gi-chess-pawn',
  'gi-chess-queen',
  'gi-chess-rook',
  'gi-click',
  'gi-clubs',
  'gi-cobra',
  'gi-colt-m1911',
  'gi-combination-lock',
  'gi-console-controller',
  'gi-crescent-blade',
  'gi-cultist',
  'gi-cz-skorpion',
  'gi-d10',
  'gi-d12',
  'gi-d4',
  'gi-desert-eagle',
  'gi-diamonds',
  'gi-divided-square',
  'gi-donkey',
  'gi-dress',
  'gi-drop-weapon',
  'gi-evil-eyes',
  'gi-f1-car',
  'gi-famas',
  'gi-fangs',
  'gi-fat',
  'gi-fetus',
  'gi-fist',
  'gi-flatbed',
  'gi-flatbed-covered',
  'gi-fn-fal',
  'gi-footsteps',
  'gi-fruit-bowl',
  'gi-gas-mask',
  'gi-gladius',
  'gi-glider',
  'gi-glock',
  'gi-goat',
  'gi-halt',
  'gi-ham-shank',
  'gi-hang-glider',
  'gi-hasty-grave',
  'gi-headshot',
  'gi-hearing-disabled',
  'gi-hearts',
  'gi-hexes',
  'gi-inverted-dice-1',
  'gi-inverted-dice-2',
  'gi-inverted-dice-3',
  'gi-inverted-dice-4',
  'gi-inverted-dice-5',
  'gi-inverted-dice-6',
  'gi-iron-cross',
  'gi-jeep',
  'gi-joint',
  'gi-kevlar-vest',
  'gi-knockout',
  'gi-laser-burst',
  'gi-lee-enfield',
  'gi-logging',
  'gi-long-legged-spider',
  'gi-luger',
  'gi-m3-grease-gun',
  'gi-mac-10',
  'gi-machine-gun',
  'gi-minefield',
  'gi-molecule',
  'gi-mounted-knight',
  'gi-mp-40',
  'gi-mp5',
  'gi-mp5k',
  'gi-musket',
  'gi-nuclear-bomb',
  'gi-oil-drum',
  'gi-open-chest',
  'gi-open-palm',
  'gi-open-treasure-chest',
  'gi-orbit',
  'gi-p90',
  'gi-pauldrons',
  'gi-pc',
  'gi-pegasus',
  'gi-pentacle',
  'gi-pestle-mortar',
  'gi-pickelhaube',
  'gi-pig',
  'gi-platform',
  'gi-pocket-watch',
  'gi-pteruges',
  'gi-race-car',
  'gi-raise-skeleton',
  'gi-raise-zombie',
  'gi-rank-1',
  'gi-rank-2',
  'gi-rank-3',
  'gi-read',
  'gi-retro-controller',
  'gi-revolver',
  'gi-sea-creature',
  'gi-shield-disabled',
  'gi-siege-ram',
  'gi-sight-disabled',
  'gi-siren',
  'gi-skeleton',
  'gi-smartphone',
  'gi-solar-power',
  'gi-sound-waves',
  'gi-spades',
  'gi-spectre-m4',
  'gi-spiked-ball',
  'gi-spiked-bat',
  'gi-spinning-top',
  'gi-spotted-bug',
  'gi-stahlhelm',
  'gi-steel-claws',
  'gi-steel-door',
  'gi-steyr-aug',
  'gi-stick-grenade',
  'gi-stiletto',
  'gi-stopwatch',
  'gi-swirled-shell',
  'gi-switchblade',
  'gi-tablet',
  'gi-talk',
  'gi-tank-tread',
  'gi-tec-9',
  'gi-telescopic-baton',
  'gi-teller-mine',
  'gi-thompson-m1',
  'gi-thompson-m1928',
  'gi-topaz',
  'gi-trench-body-armor',
  'gi-trench-knife',
  'gi-trench-spade',
  'gi-troll',
  'gi-walther-ppk',
  'gi-winchester-rifle',
  'gi-wooden-helmet',
  'gi-zeppelin',
  'gi-bear-face',
  'gi-digital-trace',
  'gi-potion-of-madness',
  'gi-infinity',
  'gi-salmon',
  'gi-abstract-001',
  'gi-abstract-002',
  'gi-abstract-003',
  'gi-abstract-004',
  'gi-abstract-005',
  'gi-abstract-006',
  'gi-abstract-007',
  'gi-abstract-008',
  'gi-abstract-009',
  'gi-abstract-010',
  'gi-abstract-011',
  'gi-abstract-012',
  'gi-abstract-013',
  'gi-abstract-014',
  'gi-abstract-015',
  'gi-abstract-016',
  'gi-abstract-017',
  'gi-abstract-018',
  'gi-abstract-019',
  'gi-abstract-020',
  'gi-abstract-021',
  'gi-abstract-022',
  'gi-abstract-023',
  'gi-abstract-024',
  'gi-abstract-025',
  'gi-abstract-026',
  'gi-abstract-027',
  'gi-abstract-028',
  'gi-abstract-029',
  'gi-abstract-030',
  'gi-abstract-031',
  'gi-abstract-032',
  'gi-abstract-033',
  'gi-abstract-034',
  'gi-abstract-035',
  'gi-abstract-036',
  'gi-abstract-037',
  'gi-abstract-038',
  'gi-abstract-039',
  'gi-abstract-040',
  'gi-abstract-041',
  'gi-abstract-042',
  'gi-abstract-043',
  'gi-abstract-044',
  'gi-abstract-045',
  'gi-abstract-046',
  'gi-abstract-047',
  'gi-abstract-048',
  'gi-abstract-049',
  'gi-abstract-050',
  'gi-abstract-051',
  'gi-abstract-052',
  'gi-abstract-053',
  'gi-abstract-054',
  'gi-abstract-055',
  'gi-abstract-056',
  'gi-abstract-057',
  'gi-abstract-058',
  'gi-abstract-059',
  'gi-abstract-060',
  'gi-abstract-061',
  'gi-abstract-062',
  'gi-abstract-063',
  'gi-abstract-064',
  'gi-abstract-065',
  'gi-abstract-066',
  'gi-abstract-067',
  'gi-abstract-068',
  'gi-abstract-069',
  'gi-abstract-070',
  'gi-abstract-071',
  'gi-abstract-072',
  'gi-abstract-073',
  'gi-abstract-074',
  'gi-abstract-075',
  'gi-abstract-076',
  'gi-abstract-077',
  'gi-abstract-078',
  'gi-abstract-079',
  'gi-abstract-080',
  'gi-abstract-081',
  'gi-abstract-082',
  'gi-abstract-083',
  'gi-abstract-084',
  'gi-abstract-085',
  'gi-abstract-086',
  'gi-abstract-087',
  'gi-abstract-088',
  'gi-abstract-089',
  'gi-abstract-090',
  'gi-abstract-091',
  'gi-abstract-092',
  'gi-abstract-093',
  'gi-abstract-094',
  'gi-abstract-095',
  'gi-abstract-096',
  'gi-abstract-097',
  'gi-abstract-098',
  'gi-abstract-099',
  'gi-abstract-100',
  'gi-abstract-101',
  'gi-abstract-102',
  'gi-abstract-103',
  'gi-abstract-104',
  'gi-abstract-105',
  'gi-abstract-106',
  'gi-abstract-107',
  'gi-abstract-108',
  'gi-abstract-109',
  'gi-abstract-110',
  'gi-abstract-111',
  'gi-abstract-112',
  'gi-abstract-113',
  'gi-abstract-114',
  'gi-abstract-115',
  'gi-abstract-116',
  'gi-abstract-117',
  'gi-abstract-118',
  'gi-abstract-119',
  'gi-abstract-120',
  'gi-abstract-121',
  'gi-black-book',
  'gi-chain-lightning',
  'gi-chain-mail',
  'gi-gold-bar',
  'gi-orb-wand',
  'gi-round-shield',
  'gi-white-book',
  'gi-skull-with-syringe',
  'gi-violin',
  'gi-heart-minus',
  'gi-heart-plus'
]
